export const DictionaryPhotoshop_ja_JP = [
    {
        id: 1,
        label: 'Photoshop > Adobe Photoshop について...',
        placement: 'MenuBar',
        name: 'Adobe Photoshop について...',
    },
    {
        id: 10,
        label: 'ファイル > 新規...',
        placement: 'MenuBar',
        name: '新規...',
    },
    {
        id: 20,
        label: 'ファイル > 開く...',
        placement: 'MenuBar',
        name: '開く...',
    },
    {
        id: 22,
        label: 'ファイル > スマートオブジェクトとして開く...',
        placement: 'MenuBar',
        name: 'スマートオブジェクトとして開く...',
    },
    {
        id: 30,
        label: 'ファイル > 保存',
        placement: 'MenuBar',
        name: '保存',
    },
    {
        id: 31,
        label: 'ファイル > 閉じる',
        placement: 'MenuBar',
        name: '閉じる',
    },
    {
        id: 32,
        label: 'ファイル > 別名で保存...',
        placement: 'MenuBar',
        name: '別名で保存...',
    },
    {
        id: 33,
        label: 'ファイル > コピーを保存...',
        placement: 'MenuBar',
        name: 'コピーを保存...',
    },
    {
        id: 34,
        label: 'ファイル > 復帰',
        placement: 'MenuBar',
        name: '復帰',
    },
    {
        id: 36,
        label: 'Photoshop > Photoshop を終了',
        placement: 'MenuBar',
        name: 'Photoshop を終了',
    },
    {
        id: 37,
        label: 'ファイル > すべてを閉じる',
        placement: 'MenuBar',
        name: 'すべてを閉じる',
    },
    {
        id: 46,
        label: 'ファイル > その他を閉じる',
        placement: 'MenuBar',
        name: 'その他を閉じる',
    },
    {
        id: 101,
        label: '編集 > 取り消し(O)',
        placement: 'MenuBar',
        name: '取り消し(O)',
    },
    {
        id: 103,
        label: '編集 > カット',
        placement: 'MenuBar',
        name: 'カット',
    },
    {
        id: 104,
        label: '編集 > コピー',
        placement: 'MenuBar',
        name: 'コピー',
    },
    {
        id: 105,
        label: '編集 > ペースト',
        placement: 'MenuBar',
        name: 'ペースト',
    },
    {
        id: 106,
        label: '編集 > 消去',
        placement: 'MenuBar',
        name: '消去',
    },
    {
        id: 132,
        label: '編集 > やり直し(O)',
        placement: 'MenuBar',
        name: 'やり直し(O)',
    },
    {
        id: 133,
        label: '編集 > 最後の状態を切り替え',
        placement: 'MenuBar',
        name: '最後の状態を切り替え',
    },
    {
        id: 177,
        label: 'ファイル > 1 部プリント',
        placement: 'MenuBar',
        name: '1 部プリント',
    },
    {
        id: 1001,
        label: 'ウィンドウ > アレンジ > 新規ウィンドウ',
        placement: 'MenuBar',
        name: '新規ウィンドウ',
    },
    {
        id: 1002,
        label: '表示 > 定規',
        placement: 'MenuBar',
        name: '定規',
    },
    {
        id: 1004,
        label: '表示 > ズームイン',
        placement: 'MenuBar',
        name: 'ズームイン',
    },
    {
        id: 1005,
        label: '表示 > ズームアウト',
        placement: 'MenuBar',
        name: 'ズームアウト',
    },
    {
        id: 1006,
        label: 'イメージ > モード > モノクロ 2 階調(B)',
        placement: 'MenuBar',
        name: 'モノクロ 2 階調(B)',
    },
    {
        id: 1007,
        label: 'イメージ > モード > グレースケール(G)',
        placement: 'MenuBar',
        name: 'グレースケール(G)',
    },
    {
        id: 1008,
        label: 'イメージ > モード > ダブルトーン(D)',
        placement: 'MenuBar',
        name: 'ダブルトーン(D)',
    },
    {
        id: 1009,
        label: 'イメージ > モード > インデックスカラー(I)',
        placement: 'MenuBar',
        name: 'インデックスカラー(I)',
    },
    {
        id: 1010,
        label: 'イメージ > モード > RGB カラー',
        placement: 'MenuBar',
        name: 'RGB カラー',
    },
    {
        id: 1011,
        label: 'イメージ > モード > CMYK カラー',
        placement: 'MenuBar',
        name: 'CMYK カラー',
    },
    {
        id: 1014,
        label: 'イメージ > モード > マルチチャンネル',
        placement: 'MenuBar',
        name: 'マルチチャンネル',
    },
    {
        id: 1016,
        label: '選択範囲 > 選択を解除(D)',
        placement: 'MenuBar',
        name: '選択を解除(D)',
    },
    {
        id: 1017,
        label: '選択範囲 > すべてを選択(A)',
        placement: 'MenuBar',
        name: 'すべてを選択(A)',
    },
    {
        id: 1018,
        label: '選択範囲 > 選択範囲を反転',
        placement: 'MenuBar',
        name: '選択範囲を反転',
    },
    {
        id: 1019,
        label: 'フィルター > フィルターの再実行',
        placement: 'MenuBar',
        name: 'フィルターの再実行',
    },
    {
        id: 1021,
        label: 'ウィンドウ > チャンネル',
        placement: 'MenuBar',
        name: 'チャンネル',
    },
    {
        id: 1025,
        label: 'ウィンドウ > ブラシ設定',
        placement: 'MenuBar',
        name: 'ブラシ設定',
    },
    {
        id: 1029,
        label: '編集 > ブラシを定義...',
        placement: 'MenuBar',
        name: 'ブラシを定義...',
    },
    {
        id: 1030,
        label: 'イメージ > 画像解像度...',
        placement: 'MenuBar',
        name: '画像解像度...',
    },
    {
        id: 1031,
        label: 'イメージ > カンバスサイズ...',
        placement: 'MenuBar',
        name: 'カンバスサイズ...',
    },
    {
        id: 1032,
        label: 'ファイル > 埋め込みを配置...',
        placement: 'MenuBar',
        name: '埋め込みを配置...',
    },
    {
        id: 1033,
        label: '選択範囲 > 選択範囲を拡張',
        placement: 'MenuBar',
        name: '選択範囲を拡張',
    },
    {
        id: 1034,
        label: '選択範囲 > 近似色を選択',
        placement: 'MenuBar',
        name: '近似色を選択',
    },
    {
        id: 1035,
        label: '選択範囲 > 選択範囲を変更 > 境界線...',
        placement: 'MenuBar',
        name: '境界線...',
    },
    {
        id: 1036,
        label: '選択範囲 > 選択範囲を変更 > 境界をぼかす...',
        placement: 'MenuBar',
        name: '境界をぼかす...',
    },
    {
        id: 1037,
        label: 'レイヤー > マッティング > フリンジ削除...',
        placement: 'MenuBar',
        name: 'フリンジ削除...',
    },
    {
        id: 1038,
        label: '編集 > パターンを定義...',
        placement: 'MenuBar',
        name: 'パターンを定義...',
    },
    {
        id: 1040,
        label: '編集 > 特殊ペースト > 選択範囲内へペースト',
        placement: 'MenuBar',
        name: '選択範囲内へペースト',
    },
    {
        id: 1042,
        label: '編集 > 塗りつぶし...',
        placement: 'MenuBar',
        name: '塗りつぶし...',
    },
    {
        id: 1043,
        label: '編集 > 境界線を描く...',
        placement: 'MenuBar',
        name: '境界線を描く...',
    },
    {
        id: 1044,
        label: 'イメージ > 切り抜き',
        placement: 'MenuBar',
        name: '切り抜き',
    },
    {
        id: 1045,
        label: 'イメージ > モード > カラーテーブル...',
        placement: 'MenuBar',
        name: 'カラーテーブル...',
    },
    {
        id: 1046,
        label: 'ウィンドウ > カラー',
        placement: 'MenuBar',
        name: 'カラー',
    },
    {
        id: 1052,
        label: 'イメージ > モード > Lab カラー',
        placement: 'MenuBar',
        name: 'Lab カラー',
    },
    {
        id: 1055,
        label: 'ウィンドウ > 情報',
        placement: 'MenuBar',
        name: '情報',
    },
    {
        id: 1058,
        label: 'ウィンドウ > コピーソース',
        placement: 'MenuBar',
        name: 'コピーソース',
    },
    {
        id: 1065,
        label: 'ウィンドウ > パス',
        placement: 'MenuBar',
        name: 'パス',
    },
    {
        id: 1080,
        label: 'イメージ > トリミング...',
        placement: 'MenuBar',
        name: 'トリミング...',
    },
    {
        id: 1081,
        label: 'イメージ > すべての領域を表示',
        placement: 'MenuBar',
        name: 'すべての領域を表示',
    },
    {
        id: 1093,
        label: 'イメージ > トラッピング...',
        placement: 'MenuBar',
        name: 'トラッピング...',
    },
    {
        id: 1098,
        label: 'ウィンドウ > レイヤー',
        placement: 'MenuBar',
        name: 'レイヤー',
    },
    {
        id: 1099,
        label: 'レイヤー > 新規 > レイヤー...',
        placement: 'MenuBar',
        name: 'レイヤー...',
    },
    {
        id: 1100,
        label: 'レイヤー > 削除 > レイヤー(L)',
        placement: 'MenuBar',
        name: 'レイヤー(L)',
    },
    {
        id: 1103,
        label: 'レイヤー > レイヤーオプション...',
        placement: 'MenuBar',
        name: 'レイヤーオプション...',
    },
    {
        id: 1105,
        label: '表示 > 色の校正',
        placement: 'MenuBar',
        name: '色の校正',
    },
    {
        id: 1106,
        label: '表示 > 色域外警告',
        placement: 'MenuBar',
        name: '色域外警告',
    },
    {
        id: 1107,
        label: '編集 > 結合部分をコピー',
        placement: 'MenuBar',
        name: '結合部分をコピー',
    },
    {
        id: 1108,
        label: '選択範囲 > 選択範囲を変更 > 滑らかに...',
        placement: 'MenuBar',
        name: '滑らかに...',
    },
    {
        id: 1109,
        label: '選択範囲 > 選択範囲を変更 > 拡張...',
        placement: 'MenuBar',
        name: '拡張...',
    },
    {
        id: 1110,
        label: '選択範囲 > 選択範囲を変更 > 縮小...',
        placement: 'MenuBar',
        name: '縮小...',
    },
    {
        id: 1111,
        label: 'ウィンドウ > オプション',
        placement: 'MenuBar',
        name: 'オプション',
    },
    {
        id: 1112,
        label: '表示 > ピクセル縦横比を確認',
        placement: 'MenuBar',
        name: 'ピクセル縦横比を確認',
    },
    {
        id: 1114,
        label: 'レイヤー > レイヤーを非表示',
        placement: 'MenuBar',
        name: 'レイヤーを非表示',
    },
    {
        id: 1115,
        label: '選択範囲 > 選択とマスク...',
        placement: 'MenuBar',
        name: '選択とマスク...',
    },
    {
        id: 1119,
        label: 'ウィンドウ > スウォッチ',
        placement: 'MenuBar',
        name: 'スウォッチ',
    },
    {
        id: 1134,
        label: 'イメージ > 複製...',
        placement: 'MenuBar',
        name: '複製...',
    },
    {
        id: 1135,
        label: 'レイヤー > レイヤーを複製...',
        placement: 'MenuBar',
        name: 'レイヤーを複製...',
    },
    {
        id: 1137,
        label: 'ファイル > ファイル情報...',
        placement: 'MenuBar',
        name: 'ファイル情報...',
    },
    {
        id: 1139,
        label: 'レイヤー > 表示レイヤーを結合',
        placement: 'MenuBar',
        name: '表示レイヤーを結合',
    },
    {
        id: 1141,
        label: 'レイヤー > 画像を統合',
        placement: 'MenuBar',
        name: '画像を統合',
    },
    {
        id: 1152,
        label: '選択範囲 > 色域指定...',
        placement: 'MenuBar',
        name: '色域指定...',
    },
    {
        id: 1153,
        label: 'イメージ > 画像操作...',
        placement: 'MenuBar',
        name: '画像操作...',
    },
    {
        id: 1154,
        label: '編集 > フェード(D)...',
        placement: 'MenuBar',
        name: 'フェード(D)...',
    },
    {
        id: 1156,
        label: 'レイヤー > レイヤーマスク > すべての領域を隠す',
        placement: 'MenuBar',
        name: 'すべての領域を隠す',
    },
    {
        id: 1157,
        label: 'レイヤー > レイヤーマスク > すべての領域を表示',
        placement: 'MenuBar',
        name: 'すべての領域を表示',
    },
    {
        id: 1158,
        label: 'レイヤー > レイヤーマスク > 選択範囲外をマスク',
        placement: 'MenuBar',
        name: '選択範囲外をマスク',
    },
    {
        id: 1159,
        label: 'レイヤー > レイヤーマスク > 使用(B)',
        placement: 'MenuBar',
        name: '使用(B)',
    },
    {
        id: 1161,
        label: 'イメージ > モード > 8 bit/チャンネル(A)',
        placement: 'MenuBar',
        name: '8 bit/チャンネル(A)',
    },
    {
        id: 1162,
        label: 'イメージ > モード > 16 bit/チャンネル(N)',
        placement: 'MenuBar',
        name: '16 bit/チャンネル(N)',
    },
    {
        id: 1163,
        label: 'ウィンドウ > ナビゲーター',
        placement: 'MenuBar',
        name: 'ナビゲーター',
    },
    {
        id: 1166,
        label: 'レイヤー > レイヤーを結合(E)',
        placement: 'MenuBar',
        name: 'レイヤーを結合(E)',
    },
    {
        id: 1167,
        label: 'ウィンドウ > レイヤーカンプ',
        placement: 'MenuBar',
        name: 'レイヤーカンプ',
    },
    {
        id: 1168,
        label: 'レイヤー > レイヤーマスク > 選択範囲をマスク',
        placement: 'MenuBar',
        name: '選択範囲をマスク',
    },
    {
        id: 1169,
        label: 'ファイル > 自動処理 > ドロップレットを作成...',
        placement: 'MenuBar',
        name: 'ドロップレットを作成...',
    },
    {
        id: 1170,
        label: 'ウィンドウ > アクション',
        placement: 'MenuBar',
        name: 'アクション',
    },
    {
        id: 1180,
        label: 'ファイル > 自動処理 > バッチ...',
        placement: 'MenuBar',
        name: 'バッチ...',
    },
    {
        id: 1188,
        label: 'ウィンドウ > タイムライン',
        placement: 'MenuBar',
        name: 'タイムライン',
    },
    {
        id: 1190,
        label: '表示 > 100%',
        placement: 'MenuBar',
        name: '100%',
    },
    {
        id: 1191,
        label: '表示 > プリントサイズ',
        placement: 'MenuBar',
        name: 'プリントサイズ',
    },
    {
        id: 1192,
        label: '表示 > 画面サイズに合わせる',
        placement: 'MenuBar',
        name: '画面サイズに合わせる',
    },
    {
        id: 1194,
        label: 'ウィンドウ > ツール',
        placement: 'MenuBar',
        name: 'ツール',
    },
    {
        id: 1195,
        label: '表示 > アートボードを画面サイズに合わせる',
        placement: 'MenuBar',
        name: 'アートボードを画面サイズに合わせる',
    },
    {
        id: 1199,
        label: 'ウィンドウ > ヒストリー',
        placement: 'MenuBar',
        name: 'ヒストリー',
    },
    {
        id: 1200,
        label: '選択範囲 > 選択範囲を読み込む...',
        placement: 'MenuBar',
        name: '選択範囲を読み込む...',
    },
    {
        id: 1202,
        label: '表示 > ピクセル縦横比 > カスタムピクセル縦横比...',
        placement: 'MenuBar',
        name: 'カスタムピクセル縦横比...',
    },
    {
        id: 1203,
        label: '表示 > ピクセル縦横比 > ピクセル縦横比を削除...',
        placement: 'MenuBar',
        name: 'ピクセル縦横比を削除...',
    },
    {
        id: 1204,
        label: '表示 > ピクセル縦横比 > ピクセル縦横比を初期化...',
        placement: 'MenuBar',
        name: 'ピクセル縦横比を初期化...',
    },
    {
        id: 1205,
        label: '表示 > ピクセル縦横比 > 正方形ピクセル',
        placement: 'MenuBar',
        name: '正方形ピクセル',
    },
    {
        id: 1206,
        label: 'イメージ > モード > 32 bit/チャンネル',
        placement: 'MenuBar',
        name: '32 bit/チャンネル',
    },
    {
        id: 1211,
        label: '編集 > プリセット > プリセットを移行',
        placement: 'MenuBar',
        name: 'プリセットを移行',
    },
    {
        id: 1212,
        label: '編集 > プロファイルの指定...',
        placement: 'MenuBar',
        name: 'プロファイルの指定...',
    },
    {
        id: 1213,
        label: '編集 > プロファイル変換(V)...',
        placement: 'MenuBar',
        name: 'プロファイル変換(V)...',
    },
    {
        id: 1214,
        label: '編集 > プリセット > プリセットマネージャー...',
        placement: 'MenuBar',
        name: 'プリセットマネージャー...',
    },
    {
        id: 1215,
        label: '編集 > Adobe PDF プリセット...',
        placement: 'MenuBar',
        name: 'Adobe PDF プリセット...',
    },
    {
        id: 1217,
        label: '表示 > 100% 表示',
        placement: 'MenuBar',
        name: '100% 表示',
    },
    {
        id: 1223,
        label: '書式 > 方向 > 横書き',
        placement: 'MenuBar',
        name: '横書き',
    },
    {
        id: 1224,
        label: '書式 > 方向 > 縦書き',
        placement: 'MenuBar',
        name: '縦書き',
    },
    {
        id: 1228,
        label: '書式 > 作業用パスを作成',
        placement: 'MenuBar',
        name: '作業用パスを作成',
    },
    {
        id: 1229,
        label: '書式 > シェイプに変換',
        placement: 'MenuBar',
        name: 'シェイプに変換',
    },
    {
        id: 1231,
        label: 'レイヤー > 整列 > 上端',
        placement: 'MenuBar',
        name: '上端',
    },
    {
        id: 1232,
        label: 'レイヤー > 整列 > 下端',
        placement: 'MenuBar',
        name: '下端',
    },
    {
        id: 1233,
        label: 'レイヤー > 整列 > 垂直方向中央',
        placement: 'MenuBar',
        name: '垂直方向中央',
    },
    {
        id: 1234,
        label: 'レイヤー > 整列 > 左端',
        placement: 'MenuBar',
        name: '左端',
    },
    {
        id: 1235,
        label: 'レイヤー > 整列 > 右端',
        placement: 'MenuBar',
        name: '右端',
    },
    {
        id: 1236,
        label: 'レイヤー > 整列 > 水平方向中央',
        placement: 'MenuBar',
        name: '水平方向中央',
    },
    {
        id: 1237,
        label: '編集 > レイヤーを自動整列...',
        placement: 'MenuBar',
        name: 'レイヤーを自動整列...',
    },
    {
        id: 1238,
        label: '編集 > レイヤーを自動合成...',
        placement: 'MenuBar',
        name: 'レイヤーを自動合成...',
    },
    {
        id: 1239,
        label: 'レイヤー > 分布 > 垂直方向',
        placement: 'MenuBar',
        name: '垂直方向',
    },
    {
        id: 1241,
        label: 'レイヤー > 分布 > 上端',
        placement: 'MenuBar',
        name: '上端',
    },
    {
        id: 1242,
        label: 'レイヤー > 分布 > 下端',
        placement: 'MenuBar',
        name: '下端',
    },
    {
        id: 1243,
        label: 'レイヤー > 分布 > 垂直方向中央',
        placement: 'MenuBar',
        name: '垂直方向中央',
    },
    {
        id: 1245,
        label: 'レイヤー > 分布 > 左端',
        placement: 'MenuBar',
        name: '左端',
    },
    {
        id: 1246,
        label: 'レイヤー > 分布 > 右端',
        placement: 'MenuBar',
        name: '右端',
    },
    {
        id: 1247,
        label: 'レイヤー > 分布 > 水平方向中央',
        placement: 'MenuBar',
        name: '水平方向中央',
    },
    {
        id: 1249,
        label: 'レイヤー > 分布 > 水平方向',
        placement: 'MenuBar',
        name: '水平方向',
    },
    {
        id: 1281,
        label: '選択範囲 > 選択範囲を保存...',
        placement: 'MenuBar',
        name: '選択範囲を保存...',
    },
    {
        id: 1284,
        label: '表示 > 水平方向に反転',
        placement: 'MenuBar',
        name: '水平方向に反転',
    },
    {
        id: 1285,
        label: '表示 > パターンプレビュー',
        placement: 'MenuBar',
        name: 'パターンプレビュー',
    },
    {
        id: 1292,
        label: 'レイヤー > レイヤーマスク > 透明部分をマスク',
        placement: 'MenuBar',
        name: '透明部分をマスク',
    },
    {
        id: 1295,
        label: 'レイヤー > マッティング > 不要なカラーの除去...',
        placement: 'MenuBar',
        name: '不要なカラーの除去...',
    },
    {
        id: 1297,
        label: '編集 > 特殊ペースト > 同じ位置にペースト',
        placement: 'MenuBar',
        name: '同じ位置にペースト',
    },
    {
        id: 1299,
        label: '表示 > 200%',
        placement: 'MenuBar',
        name: '200%',
    },
    {
        id: 1301,
        label: 'レイヤー > レイヤースタイル > ドロップシャドウ...',
        placement: 'MenuBar',
        name: 'ドロップシャドウ...',
    },
    {
        id: 1302,
        label: 'レイヤー > レイヤースタイル > シャドウ (内側)...',
        placement: 'MenuBar',
        name: 'シャドウ (内側)...',
    },
    {
        id: 1303,
        label: 'レイヤー > レイヤースタイル > 光彩 (外側)...',
        placement: 'MenuBar',
        name: '光彩 (外側)...',
    },
    {
        id: 1304,
        label: 'レイヤー > レイヤースタイル > 光彩 (内側)...',
        placement: 'MenuBar',
        name: '光彩 (内側)...',
    },
    {
        id: 1305,
        label: 'レイヤー > レイヤースタイル > ベベルとエンボス...',
        placement: 'MenuBar',
        name: 'ベベルとエンボス...',
    },
    {
        id: 1306,
        label: 'レイヤー > レイヤースタイル > すべての効果を隠す',
        placement: 'MenuBar',
        name: 'すべての効果を隠す',
    },
    {
        id: 1307,
        label: 'レイヤー > レイヤースタイル > 包括光源...',
        placement: 'MenuBar',
        name: '包括光源...',
    },
    {
        id: 1308,
        label: 'レイヤー > レイヤースタイル > レイヤーを作成',
        placement: 'MenuBar',
        name: 'レイヤーを作成',
    },
    {
        id: 1312,
        label: 'レイヤー > レイヤースタイル > サテン...',
        placement: 'MenuBar',
        name: 'サテン...',
    },
    {
        id: 1313,
        label: 'レイヤー > レイヤースタイル > 境界線...',
        placement: 'MenuBar',
        name: '境界線...',
    },
    {
        id: 1314,
        label: 'レイヤー > レイヤースタイル > レイヤースタイルをコピー',
        placement: 'MenuBar',
        name: 'レイヤースタイルをコピー',
    },
    {
        id: 1315,
        label: 'レイヤー > レイヤースタイル > レイヤースタイルをペースト',
        placement: 'MenuBar',
        name: 'レイヤースタイルをペースト',
    },
    {
        id: 1327,
        label: 'レイヤー > レイヤースタイル > 効果を拡大・縮小...',
        placement: 'MenuBar',
        name: '効果を拡大・縮小...',
    },
    {
        id: 1331,
        label: 'レイヤー > レイヤースタイル > レイヤー効果...',
        placement: 'MenuBar',
        name: 'レイヤー効果...',
    },
    {
        id: 1335,
        label: 'レイヤー > レイヤースタイル > カラーオーバーレイ...',
        placement: 'MenuBar',
        name: 'カラーオーバーレイ...',
    },
    {
        id: 1336,
        label: 'レイヤー > レイヤースタイル > グラデーションオーバーレイ...',
        placement: 'MenuBar',
        name: 'グラデーションオーバーレイ...',
    },
    {
        id: 1337,
        label: 'レイヤー > レイヤースタイル > パターンオーバーレイ...',
        placement: 'MenuBar',
        name: 'パターンオーバーレイ...',
    },
    {
        id: 1339,
        label: 'レイヤー > レイヤースタイル > レイヤースタイルを消去',
        placement: 'MenuBar',
        name: 'レイヤースタイルを消去',
    },
    {
        id: 1355,
        label: 'ウィンドウ > 注釈',
        placement: 'MenuBar',
        name: '注釈',
    },
    {
        id: 1382,
        label: 'ウィンドウ > ヒストグラム',
        placement: 'MenuBar',
        name: 'ヒストグラム',
    },
    {
        id: 1396,
        label: 'ウィンドウ > ブラシ',
        placement: 'MenuBar',
        name: 'ブラシ',
    },
    {
        id: 1429,
        label: 'プラグイン > プラグインパネル',
        placement: 'MenuBar',
        name: 'プラグインパネル',
    },
    {
        id: 1430,
        label: 'プラグイン > プラグインを参照...',
        placement: 'MenuBar',
        name: 'プラグインを参照...',
    },
    {
        id: 1431,
        label: 'プラグイン > プラグインを管理...',
        placement: 'MenuBar',
        name: 'プラグインを管理...',
    },
    {
        id: 1460,
        label: '選択範囲 > 焦点領域...',
        placement: 'MenuBar',
        name: '焦点領域...',
    },
    {
        id: 1461,
        label: '選択範囲 > 被写体を選択',
        placement: 'MenuBar',
        name: '被写体を選択',
    },
    {
        id: 1462,
        label: '選択範囲 > 空を選択',
        placement: 'MenuBar',
        name: '空を選択',
    },
    {
        id: 1502,
        label: 'ファイル > 読み込み > 画像をデバイスから...',
        placement: 'MenuBar',
        name: '画像をデバイスから...',
    },
    {
        id: 1503,
        label: 'ファイル > iPhone または iPad から読み込み',
        placement: 'MenuBar',
        name: 'iPhone または iPad から読み込み',
    },
    {
        id: 1510,
        label: '編集 > コンテンツに応じた塗りつぶし ...',
        placement: 'MenuBar',
        name: 'コンテンツに応じた塗りつぶし ...',
    },
    {
        id: 1520,
        label: 'ファイル > Bridge で参照...',
        placement: 'MenuBar',
        name: 'Bridge で参照...',
    },
    {
        id: 1522,
        label: '書式 > Adobe Fonts から追加...',
        placement: 'MenuBar',
        name: 'Adobe Fonts から追加...',
    },
    {
        id: 1530,
        label: 'ファイル > 閉じて Bridge を起動...',
        placement: 'MenuBar',
        name: '閉じて Bridge を起動...',
    },
    {
        id: 1613,
        label: '編集 > リモート接続...',
        placement: 'MenuBar',
        name: 'リモート接続...',
    },
    {
        id: 1676,
        label: 'ファイル > スクリプト > 参照...',
        placement: 'MenuBar',
        name: '参照...',
    },
    {
        id: 1695,
        label: 'ファイル > 書き出し > Web 用に保存...',
        placement: 'MenuBar',
        name: 'Web 用に保存...',
    },
    {
        id: 1696,
        label: 'ファイル > 自動処理 > PDF スライドショー...',
        placement: 'MenuBar',
        name: 'PDF スライドショー...',
    },
    {
        id: 1701,
        label: 'イメージ > 色調補正 > 階調の反転',
        placement: 'MenuBar',
        name: '階調の反転',
    },
    {
        id: 1702,
        label: 'イメージ > 色調補正 > 平均化 (イコライズ)',
        placement: 'MenuBar',
        name: '平均化 (イコライズ)',
    },
    {
        id: 1703,
        label: 'イメージ > 色調補正 > 2 階調化...',
        placement: 'MenuBar',
        name: '2 階調化...',
    },
    {
        id: 1704,
        label: 'イメージ > 色調補正 > ポスタリゼーション...',
        placement: 'MenuBar',
        name: 'ポスタリゼーション...',
    },
    {
        id: 1750,
        label: '編集 > 生成塗りつぶし...',
        placement: 'MenuBar',
        name: '生成塗りつぶし...',
    },
    {
        id: 1771,
        label: '編集 > 画像を生成...',
        placement: 'MenuBar',
        name: '画像を生成...',
    },
    {
        id: 1776,
        label: 'イメージ > 生成アップスケール...',
        placement: 'MenuBar',
        name: '生成アップスケール...',
    },
    {
        id: 1777,
        label: 'フィルター > AI ノイズ除去...',
        placement: 'MenuBar',
        name: 'AI ノイズ除去...',
    },
    {
        id: 1778,
        label: 'フィルター > AI シャープ...',
        placement: 'MenuBar',
        name: 'AI シャープ...',
    },
    {
        id: 1801,
        label: 'イメージ > 色調補正 > レベル補正...',
        placement: 'MenuBar',
        name: 'レベル補正...',
    },
    {
        id: 1802,
        label: 'イメージ > 色調補正 > トーンカーブ...',
        placement: 'MenuBar',
        name: 'トーンカーブ...',
    },
    {
        id: 1803,
        label: 'イメージ > 色調補正 > 明るさ・コントラスト...',
        placement: 'MenuBar',
        name: '明るさ・コントラスト...',
    },
    {
        id: 1804,
        label: 'イメージ > 色調補正 > カラーバランス...',
        placement: 'MenuBar',
        name: 'カラーバランス...',
    },
    {
        id: 1805,
        label: 'イメージ > 色調補正 > 色相・彩度...',
        placement: 'MenuBar',
        name: '色相・彩度...',
    },
    {
        id: 1806,
        label: 'イメージ > 色調補正 > 色の置き換え...',
        placement: 'MenuBar',
        name: '色の置き換え...',
    },
    {
        id: 1807,
        label: 'イメージ > 色調補正 > 特定色域の選択...',
        placement: 'MenuBar',
        name: '特定色域の選択...',
    },
    {
        id: 1808,
        label: 'イメージ > 自動トーン補正',
        placement: 'MenuBar',
        name: '自動トーン補正',
    },
    {
        id: 1809,
        label: 'イメージ > 色調補正 > 彩度を下げる',
        placement: 'MenuBar',
        name: '彩度を下げる',
    },
    {
        id: 1810,
        label: 'イメージ > 自動コントラスト',
        placement: 'MenuBar',
        name: '自動コントラスト',
    },
    {
        id: 1817,
        label: 'イメージ > 自動カラー補正',
        placement: 'MenuBar',
        name: '自動カラー補正',
    },
    {
        id: 1822,
        label: 'イメージ > 色調補正 > カラーの適用...',
        placement: 'MenuBar',
        name: 'カラーの適用...',
    },
    {
        id: 1824,
        label: 'イメージ > 色調補正 > 白黒...',
        placement: 'MenuBar',
        name: '白黒...',
    },
    {
        id: 1827,
        label: 'イメージ > 色調補正 > 自然な彩度...',
        placement: 'MenuBar',
        name: '自然な彩度...',
    },
    {
        id: 1900,
        label: 'イメージ > 演算...',
        placement: 'MenuBar',
        name: '演算...',
    },
    {
        id: 1942,
        label: 'レイヤー > 新規 > 背景',
        placement: 'MenuBar',
        name: '背景',
    },
    {
        id: 1943,
        label: '選択範囲 > 再選択',
        placement: 'MenuBar',
        name: '再選択',
    },
    {
        id: 1953,
        label: 'レイヤー > ベクトルマスク > すべての領域を隠す',
        placement: 'MenuBar',
        name: 'すべての領域を隠す',
    },
    {
        id: 1954,
        label: 'レイヤー > ベクトルマスク > すべての領域を表示',
        placement: 'MenuBar',
        name: 'すべての領域を表示',
    },
    {
        id: 1955,
        label: 'レイヤー > ベクトルマスク > 現在のパス',
        placement: 'MenuBar',
        name: '現在のパス',
    },
    {
        id: 1956,
        label: 'レイヤー > ベクトルマスク > 削除',
        placement: 'MenuBar',
        name: '削除',
    },
    {
        id: 1957,
        label: 'レイヤー > ラスタライズ > ベクトルマスク',
        placement: 'MenuBar',
        name: 'ベクトルマスク',
    },
    {
        id: 1959,
        label: 'レイヤー > ベクトルマスク > 使用(B)',
        placement: 'MenuBar',
        name: '使用(B)',
    },
    {
        id: 1971,
        label: '選択範囲 > 選択範囲を変形',
        placement: 'MenuBar',
        name: '選択範囲を変形',
    },
    {
        id: 2101,
        label: 'ファイル > プリント...',
        placement: 'MenuBar',
        name: 'プリント...',
    },
    {
        id: 2103,
        label: 'ファイル > 最近使用したファイルを開く > 最近使用したファイルのリストを消去',
        placement: 'MenuBar',
        name: '最近使用したファイルのリストを消去',
    },
    {
        id: 2109,
        label: 'レイヤー > ベクトルマスク > リンク',
        placement: 'MenuBar',
        name: 'リンク',
    },
    {
        id: 2201,
        label: '編集 > 変形 > 拡大・縮小',
        placement: 'MenuBar',
        name: '拡大・縮小',
    },
    {
        id: 2202,
        label: '編集 > 変形 > ゆがみ',
        placement: 'MenuBar',
        name: 'ゆがみ',
    },
    {
        id: 2203,
        label: '編集 > 変形 > 遠近法',
        placement: 'MenuBar',
        name: '遠近法',
    },
    {
        id: 2204,
        label: '編集 > 変形 > 多方向に伸縮',
        placement: 'MenuBar',
        name: '多方向に伸縮',
    },
    {
        id: 2205,
        label: '編集 > 変形 > 回転',
        placement: 'MenuBar',
        name: '回転',
    },
    {
        id: 2207,
        label: '編集 > 自由変形',
        placement: 'MenuBar',
        name: '自由変形',
    },
    {
        id: 2208,
        label: '編集 > 変形 > 180°回転',
        placement: 'MenuBar',
        name: '180°回転',
    },
    {
        id: 2209,
        label: '編集 > 変形 > 90°回転 (時計回り)',
        placement: 'MenuBar',
        name: '90°回転 (時計回り)',
    },
    {
        id: 2210,
        label: '編集 > 変形 > 90°回転 (反時計回り)',
        placement: 'MenuBar',
        name: '90°回転 (反時計回り)',
    },
    {
        id: 2211,
        label: '編集 > 変形 > 水平方向に反転',
        placement: 'MenuBar',
        name: '水平方向に反転',
    },
    {
        id: 2212,
        label: '編集 > 変形 > 垂直方向に反転',
        placement: 'MenuBar',
        name: '垂直方向に反転',
    },
    {
        id: 2217,
        label: '編集 > 変形 > 再実行',
        placement: 'MenuBar',
        name: '再実行',
    },
    {
        id: 2218,
        label: '書式 > ワープテキスト...',
        placement: 'MenuBar',
        name: 'ワープテキスト...',
    },
    {
        id: 2219,
        label: '編集 > 変形 > ワープ',
        placement: 'MenuBar',
        name: 'ワープ',
    },
    {
        id: 2220,
        label: '編集 > コンテンツに応じて拡大・縮小',
        placement: 'MenuBar',
        name: 'コンテンツに応じて拡大・縮小',
    },
    {
        id: 2221,
        label: '編集 > パペットワープ',
        placement: 'MenuBar',
        name: 'パペットワープ',
    },
    {
        id: 2224,
        label: 'フィルター > ぼかしギャラリー > 虹彩絞りぼかし...',
        placement: 'MenuBar',
        name: '虹彩絞りぼかし...',
    },
    {
        id: 2225,
        label: 'フィルター > ぼかしギャラリー > フィールドぼかし...',
        placement: 'MenuBar',
        name: 'フィールドぼかし...',
    },
    {
        id: 2226,
        label: 'フィルター > ぼかしギャラリー > チルトシフト...',
        placement: 'MenuBar',
        name: 'チルトシフト...',
    },
    {
        id: 2227,
        label: 'フィルター > ぼかしギャラリー > パスぼかし...',
        placement: 'MenuBar',
        name: 'パスぼかし...',
    },
    {
        id: 2229,
        label: 'フィルター > ぼかしギャラリー > スピンぼかし...',
        placement: 'MenuBar',
        name: 'スピンぼかし...',
    },
    {
        id: 2231,
        label: 'フィルター > 描画 > 炎...',
        placement: 'MenuBar',
        name: '炎...',
    },
    {
        id: 2232,
        label: 'フィルター > 描画 > ピクチャフレーム...',
        placement: 'MenuBar',
        name: 'ピクチャフレーム...',
    },
    {
        id: 2233,
        label: 'フィルター > 描画 > 木...',
        placement: 'MenuBar',
        name: '木...',
    },
    {
        id: 2250,
        label: '編集 > 変形 > ワープを上下に分割',
        placement: 'MenuBar',
        name: 'ワープを上下に分割',
    },
    {
        id: 2251,
        label: '編集 > 変形 > ワープを左右に分割',
        placement: 'MenuBar',
        name: 'ワープを左右に分割',
    },
    {
        id: 2252,
        label: '編集 > 変形 > ワープを斜めに分割',
        placement: 'MenuBar',
        name: 'ワープを斜めに分割',
    },
    {
        id: 2253,
        label: '編集 > 変形 > ワープの分割を削除',
        placement: 'MenuBar',
        name: 'ワープの分割を削除',
    },
    {
        id: 2254,
        label: '編集 > 変形 > ガイドの表示切り替え',
        placement: 'MenuBar',
        name: 'ガイドの表示切り替え',
    },
    {
        id: 2255,
        label: '編集 > 変形 > ワープアンカーポイントを変換',
        placement: 'MenuBar',
        name: 'ワープアンカーポイントを変換',
    },
    {
        id: 2260,
        label: '編集 > 空を置き換え...',
        placement: 'MenuBar',
        name: '空を置き換え...',
    },
    {
        id: 2304,
        label: 'Photoshop > 環境設定 > パフォーマンス...',
        placement: 'MenuBar',
        name: 'パフォーマンス...',
    },
    {
        id: 2311,
        label: 'Photoshop > 環境設定 > 一般...',
        placement: 'MenuBar',
        name: '一般...',
    },
    {
        id: 2312,
        label: 'Photoshop > 環境設定 > カーソル...',
        placement: 'MenuBar',
        name: 'カーソル...',
    },
    {
        id: 2313,
        label: 'Photoshop > 環境設定 > 透明部分・色域...',
        placement: 'MenuBar',
        name: '透明部分・色域...',
    },
    {
        id: 2314,
        label: 'Photoshop > 環境設定 > 単位・定規...',
        placement: 'MenuBar',
        name: '単位・定規...',
    },
    {
        id: 2315,
        label: 'Photoshop > 環境設定 > ガイド・グリッド・スライス...',
        placement: 'MenuBar',
        name: 'ガイド・グリッド・スライス...',
    },
    {
        id: 2316,
        label: 'Photoshop > 環境設定 > プラグイン...',
        placement: 'MenuBar',
        name: 'プラグイン...',
    },
    {
        id: 2317,
        label: 'Photoshop > 環境設定 > ファイル管理...',
        placement: 'MenuBar',
        name: 'ファイル管理...',
    },
    {
        id: 2322,
        label: 'Photoshop > 環境設定 > テキスト...',
        placement: 'MenuBar',
        name: 'テキスト...',
    },
    {
        id: 2323,
        label: 'Photoshop > 環境設定 > インターフェイス...',
        placement: 'MenuBar',
        name: 'インターフェイス...',
    },
    {
        id: 2324,
        label: 'Photoshop > 環境設定 > Camera Raw...',
        placement: 'MenuBar',
        name: 'Camera Raw...',
    },
    {
        id: 2327,
        label: 'Photoshop > 環境設定 > テクノロジープレビュー...',
        placement: 'MenuBar',
        name: 'テクノロジープレビュー...',
    },
    {
        id: 2328,
        label: 'Photoshop > 環境設定 > 仮想記憶ディスク...',
        placement: 'MenuBar',
        name: '仮想記憶ディスク...',
    },
    {
        id: 2329,
        label: 'Photoshop > 環境設定 > ヒストリーおよび Content Credentials(H)...',
        placement: 'MenuBar',
        name: 'ヒストリーおよび Content Credentials(H)...',
    },
    {
        id: 2330,
        label: 'Photoshop > 環境設定 > ツール...',
        placement: 'MenuBar',
        name: 'ツール...',
    },
    {
        id: 2331,
        label: 'Photoshop > 環境設定 > ワークスペース...',
        placement: 'MenuBar',
        name: 'ワークスペース...',
    },
    {
        id: 2332,
        label: 'Photoshop > 環境設定 > 書き出し...',
        placement: 'MenuBar',
        name: '書き出し...',
    },
    {
        id: 2332,
        label: 'ファイル > 書き出し > 書き出しの環境設定...',
        placement: 'MenuBar',
        name: '書き出しの環境設定...',
    },
    {
        id: 2333,
        label: 'Photoshop > 環境設定 > 拡張コントロール...',
        placement: 'MenuBar',
        name: '拡張コントロール...',
    },
    {
        id: 2335,
        label: 'Photoshop > 環境設定 > 画像処理...',
        placement: 'MenuBar',
        name: '画像処理...',
    },
    {
        id: 2337,
        label: 'Photoshop > 環境設定 > 通知...',
        placement: 'MenuBar',
        name: '通知...',
    },
    {
        id: 2344,
        label: '編集 > カラー設定...',
        placement: 'MenuBar',
        name: 'カラー設定...',
    },
    {
        id: 2345,
        label: '編集 > OpenColorIO 設定...',
        placement: 'MenuBar',
        name: 'OpenColorIO 設定...',
    },
    {
        id: 2361,
        label: '編集 > メモリをクリア > ヒストリー',
        placement: 'MenuBar',
        name: 'ヒストリー',
    },
    {
        id: 2701,
        label: 'レイヤー > マッティング > 黒マット削除',
        placement: 'MenuBar',
        name: '黒マット削除',
    },
    {
        id: 2703,
        label: 'レイヤー > マッティング > 白マット削除',
        placement: 'MenuBar',
        name: '白マット削除',
    },
    {
        id: 2711,
        label: 'レイヤー > 重ね順 > 最前面へ',
        placement: 'MenuBar',
        name: '最前面へ',
    },
    {
        id: 2712,
        label: 'レイヤー > 重ね順 > 前面へ',
        placement: 'MenuBar',
        name: '前面へ',
    },
    {
        id: 2713,
        label: 'レイヤー > 重ね順 > 背面へ',
        placement: 'MenuBar',
        name: '背面へ',
    },
    {
        id: 2714,
        label: 'レイヤー > 重ね順 > 最背面へ',
        placement: 'MenuBar',
        name: '最背面へ',
    },
    {
        id: 2715,
        label: 'レイヤー > 重ね順 > 逆順',
        placement: 'MenuBar',
        name: '逆順',
    },
    {
        id: 2769,
        label: 'レイヤー > スマートフィルター > スマートフィルターを使用しない',
        placement: 'MenuBar',
        name: 'スマートフィルターを使用しない',
    },
    {
        id: 2770,
        label: 'レイヤー > スマートフィルター > スマートフィルターを消去',
        placement: 'MenuBar',
        name: 'スマートフィルターを消去',
    },
    {
        id: 2802,
        label: '表示 > 校正設定 > カスタム...',
        placement: 'MenuBar',
        name: 'カスタム...',
    },
    {
        id: 2803,
        label: '表示 > 校正設定 > 作業用 CMYK',
        placement: 'MenuBar',
        name: '作業用 CMYK',
    },
    {
        id: 2804,
        label: '表示 > 校正設定 > 作業用シアン版',
        placement: 'MenuBar',
        name: '作業用シアン版',
    },
    {
        id: 2805,
        label: '表示 > 校正設定 > 作業用マゼンタ版',
        placement: 'MenuBar',
        name: '作業用マゼンタ版',
    },
    {
        id: 2806,
        label: '表示 > 校正設定 > 作業用イエロー版',
        placement: 'MenuBar',
        name: '作業用イエロー版',
    },
    {
        id: 2807,
        label: '表示 > 校正設定 > 作業用墨版',
        placement: 'MenuBar',
        name: '作業用墨版',
    },
    {
        id: 2808,
        label: '表示 > 校正設定 > 作業用 CMY 版',
        placement: 'MenuBar',
        name: '作業用 CMY 版',
    },
    {
        id: 2809,
        label: '表示 > 校正設定 > 以前の Macintosh RGB (ガンマ 1.8)',
        placement: 'MenuBar',
        name: '以前の Macintosh RGB (ガンマ 1.8)',
    },
    {
        id: 2810,
        label: '表示 > 校正設定 > インターネット標準 RGB (sRGB)',
        placement: 'MenuBar',
        name: 'インターネット標準 RGB (sRGB)',
    },
    {
        id: 2811,
        label: '表示 > 校正設定 > モニター RGB',
        placement: 'MenuBar',
        name: 'モニター RGB',
    },
    {
        id: 2815,
        label: '表示 > 校正設定 > P 型 (1 型) 色覚',
        placement: 'MenuBar',
        name: 'P 型 (1 型) 色覚',
    },
    {
        id: 2816,
        label: '表示 > 校正設定 > D 型 (2 型) 色覚',
        placement: 'MenuBar',
        name: 'D 型 (2 型) 色覚',
    },
    {
        id: 2820,
        label: 'イメージ > 解析 > ものさしツール',
        placement: 'MenuBar',
        name: 'ものさしツール',
    },
    {
        id: 2830,
        label: 'イメージ > 解析 > スケールマーカーを配置...',
        placement: 'MenuBar',
        name: 'スケールマーカーを配置...',
    },
    {
        id: 2841,
        label: 'イメージ > 解析 > 計測スケールを設定 > 初期設定(D)',
        placement: 'MenuBar',
        name: '初期設定(D)',
    },
    {
        id: 2842,
        label: 'イメージ > 解析 > 計測スケールを設定 > カスタム(C)...',
        placement: 'MenuBar',
        name: 'カスタム(C)...',
    },
    {
        id: 2851,
        label: 'イメージ > 解析 > 計測項目を選択 > カスタム(C)...',
        placement: 'MenuBar',
        name: 'カスタム(C)...',
    },
    {
        id: 2860,
        label: 'イメージ > 解析 > 計測値を記録',
        placement: 'MenuBar',
        name: '計測値を記録',
    },
    {
        id: 2880,
        label: 'ウィンドウ > 計測ログ',
        placement: 'MenuBar',
        name: '計測ログ',
    },
    {
        id: 2912,
        label: '編集 > メモリをクリア > クリップボード',
        placement: 'MenuBar',
        name: 'クリップボード',
    },
    {
        id: 2915,
        label: '編集 > メモリをクリア > すべて',
        placement: 'MenuBar',
        name: 'すべて',
    },
    {
        id: 2920,
        label: '編集 > メモリをクリア > ビデオキャッシュ',
        placement: 'MenuBar',
        name: 'ビデオキャッシュ',
    },
    {
        id: 2939,
        label: 'ウィンドウ > ワークスペース > ワークスペースをロック(L)',
        placement: 'MenuBar',
        name: 'ワークスペースをロック(L)',
    },
    {
        id: 2940,
        label: '表示 > ガイド > ガイドをロック',
        placement: 'MenuBar',
        name: 'ガイドをロック',
    },
    {
        id: 2950,
        label: '表示 > ガイド > ガイドを消去',
        placement: 'MenuBar',
        name: 'ガイドを消去',
    },
    {
        id: 2951,
        label: 'レイヤー > 削除 > 非表示レイヤー',
        placement: 'MenuBar',
        name: '非表示レイヤー',
    },
    {
        id: 2952,
        label: '表示 > ガイド > 選択したアートボードガイドを消去',
        placement: 'MenuBar',
        name: '選択したアートボードガイドを消去',
    },
    {
        id: 2953,
        label: '表示 > ガイド > カンバスガイドを消去',
        placement: 'MenuBar',
        name: 'カンバスガイドを消去',
    },
    {
        id: 2956,
        label: 'レイヤー > 新規 > レイヤーからのグループ...',
        placement: 'MenuBar',
        name: 'レイヤーからのグループ...',
    },
    {
        id: 2957,
        label: 'レイヤー > レイヤーをロック...',
        placement: 'MenuBar',
        name: 'レイヤーをロック...',
    },
    {
        id: 2958,
        label: 'レイヤー > レイヤーをグループ化',
        placement: 'MenuBar',
        name: 'レイヤーをグループ化',
    },
    {
        id: 2959,
        label: 'レイヤー > レイヤーのグループ解除',
        placement: 'MenuBar',
        name: 'レイヤーのグループ解除',
    },
    {
        id: 2960,
        label: 'レイヤー > リンクしたレイヤーを選択',
        placement: 'MenuBar',
        name: 'リンクしたレイヤーを選択',
    },
    {
        id: 2961,
        label: 'レイヤー > レイヤーをリンク',
        placement: 'MenuBar',
        name: 'レイヤーをリンク',
    },
    {
        id: 2962,
        label: '選択範囲 > すべてのレイヤー',
        placement: 'MenuBar',
        name: 'すべてのレイヤー',
    },
    {
        id: 2963,
        label: '選択範囲 > レイヤーの選択を解除',
        placement: 'MenuBar',
        name: 'レイヤーの選択を解除',
    },
    {
        id: 2967,
        label: '表示 > スライスをロック',
        placement: 'MenuBar',
        name: 'スライスをロック',
    },
    {
        id: 2969,
        label: '表示 > スライスを消去',
        placement: 'MenuBar',
        name: 'スライスを消去',
    },
    {
        id: 2970,
        label: 'レイヤー > 新規 > コピーしてレイヤー作成',
        placement: 'MenuBar',
        name: 'コピーしてレイヤー作成',
    },
    {
        id: 2971,
        label: 'レイヤー > 新規 > 選択範囲をカットしたレイヤー',
        placement: 'MenuBar',
        name: '選択範囲をカットしたレイヤー',
    },
    {
        id: 2972,
        label: 'レイヤー > クリッピングマスクを作成',
        placement: 'MenuBar',
        name: 'クリッピングマスクを作成',
    },
    {
        id: 2976,
        label: 'レイヤー > 新規 > グループ...',
        placement: 'MenuBar',
        name: 'グループ...',
    },
    {
        id: 2980,
        label: 'レイヤー > スマートオブジェクト > スマートオブジェクトに変換',
        placement: 'MenuBar',
        name: 'スマートオブジェクトに変換',
    },
    {
        id: 2981,
        label: 'レイヤー > スマートオブジェクト > スマートオブジェクトを複製',
        placement: 'MenuBar',
        name: 'スマートオブジェクトを複製',
    },
    {
        id: 2982,
        label: '選択範囲 > レイヤーを検索',
        placement: 'MenuBar',
        name: 'レイヤーを検索',
    },
    {
        id: 2983,
        label: 'レイヤー > レイヤー名の変更...',
        placement: 'MenuBar',
        name: 'レイヤー名の変更...',
    },
    {
        id: 2986,
        label: '選択範囲 > レイヤーを分離',
        placement: 'MenuBar',
        name: 'レイヤーを分離',
    },
    {
        id: 2991,
        label: 'イメージ > 画像の回転 > 90°(時計回り)',
        placement: 'MenuBar',
        name: '90°(時計回り)',
    },
    {
        id: 2992,
        label: 'イメージ > 画像の回転 > 90°(反時計回り)',
        placement: 'MenuBar',
        name: '90°(反時計回り)',
    },
    {
        id: 2993,
        label: 'イメージ > 画像の回転 > 180°',
        placement: 'MenuBar',
        name: '180°',
    },
    {
        id: 2994,
        label: 'イメージ > 画像の回転 > 角度入力...',
        placement: 'MenuBar',
        name: '角度入力...',
    },
    {
        id: 2996,
        label: 'イメージ > 画像の回転 > カンバスを左右に反転',
        placement: 'MenuBar',
        name: 'カンバスを左右に反転',
    },
    {
        id: 2997,
        label: 'イメージ > 画像の回転 > カンバスを上下に反転',
        placement: 'MenuBar',
        name: 'カンバスを上下に反転',
    },
    {
        id: 3056,
        label: 'イメージ > 色調補正 > チャンネルミキサー...',
        placement: 'MenuBar',
        name: 'チャンネルミキサー...',
    },
    {
        id: 3062,
        label: 'イメージ > 色調補正 > グラデーションマップ...',
        placement: 'MenuBar',
        name: 'グラデーションマップ...',
    },
    {
        id: 3063,
        label: 'イメージ > 色調補正 > レンズフィルター...',
        placement: 'MenuBar',
        name: 'レンズフィルター...',
    },
    {
        id: 3065,
        label: 'イメージ > 色調補正 > シャドウ・ハイライト...',
        placement: 'MenuBar',
        name: 'シャドウ・ハイライト...',
    },
    {
        id: 3066,
        label: 'イメージ > 色調補正 > カラールックアップ...',
        placement: 'MenuBar',
        name: 'カラールックアップ...',
    },
    {
        id: 3067,
        label: 'イメージ > 色調補正 > 露光量...',
        placement: 'MenuBar',
        name: '露光量...',
    },
    {
        id: 3076,
        label: 'レイヤー > スマートフィルター > フィルターマスクを使用しない',
        placement: 'MenuBar',
        name: 'フィルターマスクを使用しない',
    },
    {
        id: 3083,
        label: 'レイヤー > 新規調整レイヤー > 露光量...',
        placement: 'MenuBar',
        name: '露光量...',
    },
    {
        id: 3085,
        label: 'レイヤー > 新規調整レイヤー > カラーと自然な彩度...',
        placement: 'MenuBar',
        name: 'カラーと自然な彩度...',
    },
    {
        id: 3090,
        label: 'ファイル > リンクを配置...',
        placement: 'MenuBar',
        name: 'リンクを配置...',
    },
    {
        id: 3091,
        label: 'レイヤー > スマートオブジェクト > Finder で表示',
        placement: 'MenuBar',
        name: 'Finder で表示',
    },
    {
        id: 3092,
        label: 'ファイル > パッケージ...',
        placement: 'MenuBar',
        name: 'パッケージ...',
    },
    {
        id: 3098,
        label: 'ファイル > 自動処理 > ジェネレータープラグイン',
        placement: 'MenuBar',
        name: 'ジェネレータープラグイン',
    },
    {
        id: 3187,
        label: 'ウィンドウ > スタイル',
        placement: 'MenuBar',
        name: 'スタイル',
    },
    {
        id: 3300,
        label: '書式 > パネル > 文字パネル',
        placement: 'MenuBar',
        name: '文字パネル',
    },
    {
        id: 3300,
        label: 'ウィンドウ > 文字',
        placement: 'MenuBar',
        name: '文字',
    },
    {
        id: 3309,
        label: '書式 > OpenType > 欧文合字',
        placement: 'MenuBar',
        name: '欧文合字',
    },
    {
        id: 3310,
        label: '書式 > OpenType > オールドスタイル数字',
        placement: 'MenuBar',
        name: 'オールドスタイル数字',
    },
    {
        id: 3327,
        label: '書式 > OpenType > プロポーショナルメトリクス',
        placement: 'MenuBar',
        name: 'プロポーショナルメトリクス',
    },
    {
        id: 3334,
        label: '書式 > OpenType > スワッシュ字形',
        placement: 'MenuBar',
        name: 'スワッシュ字形',
    },
    {
        id: 3338,
        label: '書式 > OpenType > 前後関係に依存する字形',
        placement: 'MenuBar',
        name: '前後関係に依存する字形',
    },
    {
        id: 3339,
        label: '書式 > OpenType > 任意の合字',
        placement: 'MenuBar',
        name: '任意の合字',
    },
    {
        id: 3340,
        label: '書式 > OpenType > デザインのバリエーション',
        placement: 'MenuBar',
        name: 'デザインのバリエーション',
    },
    {
        id: 3341,
        label: '書式 > OpenType > タイトル用字形',
        placement: 'MenuBar',
        name: 'タイトル用字形',
    },
    {
        id: 3342,
        label: '書式 > OpenType > 装飾',
        placement: 'MenuBar',
        name: '装飾',
    },
    {
        id: 3343,
        label: '書式 > OpenType > 上付き序数表記',
        placement: 'MenuBar',
        name: '上付き序数表記',
    },
    {
        id: 3344,
        label: '書式 > OpenType > スラッシュを用いた分数',
        placement: 'MenuBar',
        name: 'スラッシュを用いた分数',
    },
    {
        id: 3345,
        label: '書式 > OpenType > JIS 78 字形',
        placement: 'MenuBar',
        name: 'JIS 78 字形',
    },
    {
        id: 3346,
        label: '書式 > OpenType > エキスパート字形',
        placement: 'MenuBar',
        name: 'エキスパート字形',
    },
    {
        id: 3347,
        label: '書式 > OpenType > 旧字体',
        placement: 'MenuBar',
        name: '旧字体',
    },
    {
        id: 3348,
        label: '書式 > OpenType > 横または縦組み用かな',
        placement: 'MenuBar',
        name: '横または縦組み用かな',
    },
    {
        id: 3349,
        label: '書式 > OpenType > 欧文イタリック',
        placement: 'MenuBar',
        name: '欧文イタリック',
    },
    {
        id: 3350,
        label: '書式 > パネル > 段落パネル',
        placement: 'MenuBar',
        name: '段落パネル',
    },
    {
        id: 3350,
        label: 'ウィンドウ > 段落',
        placement: 'MenuBar',
        name: '段落',
    },
    {
        id: 3370,
        label: '書式 > アンチエイリアス > なし',
        placement: 'MenuBar',
        name: 'なし',
    },
    {
        id: 3371,
        label: '書式 > アンチエイリアス > 鮮明',
        placement: 'MenuBar',
        name: '鮮明',
    },
    {
        id: 3372,
        label: '書式 > アンチエイリアス > 強く',
        placement: 'MenuBar',
        name: '強く',
    },
    {
        id: 3373,
        label: '書式 > アンチエイリアス > 滑らかに',
        placement: 'MenuBar',
        name: '滑らかに',
    },
    {
        id: 3374,
        label: '書式 > アンチエイリアス > シャープ',
        placement: 'MenuBar',
        name: 'シャープ',
    },
    {
        id: 3375,
        label: '書式 > アンチエイリアス > Mac LCD',
        placement: 'MenuBar',
        name: 'Mac LCD',
    },
    {
        id: 3376,
        label: '書式 > アンチエイリアス > Mac',
        placement: 'MenuBar',
        name: 'Mac',
    },
    {
        id: 3382,
        label: '書式 > テキストのシェイプタイプを変換',
        placement: 'MenuBar',
        name: 'テキストのシェイプタイプを変換',
    },
    {
        id: 3390,
        label: '書式 > すべてのテキストレイヤーを更新',
        placement: 'MenuBar',
        name: 'すべてのテキストレイヤーを更新',
    },
    {
        id: 3392,
        label: '編集 > スペルチェック...',
        placement: 'MenuBar',
        name: 'スペルチェック...',
    },
    {
        id: 3393,
        label: '編集 > 検索と置換...',
        placement: 'MenuBar',
        name: '検索と置換...',
    },
    {
        id: 3409,
        label: 'レイヤー > シェイプを結合 > シェイプを統合',
        placement: 'MenuBar',
        name: 'シェイプを統合',
    },
    {
        id: 3410,
        label: 'レイヤー > シェイプを結合 > 前面シェイプを削除',
        placement: 'MenuBar',
        name: '前面シェイプを削除',
    },
    {
        id: 3411,
        label: 'レイヤー > シェイプを結合 > 重なりでシェイプを統合',
        placement: 'MenuBar',
        name: '重なりでシェイプを統合',
    },
    {
        id: 3412,
        label: 'レイヤー > シェイプを結合 > 重なりでシェイプを削除',
        placement: 'MenuBar',
        name: '重なりでシェイプを削除',
    },
    {
        id: 3438,
        label: 'レイヤー > SVG をコピー',
        placement: 'MenuBar',
        name: 'SVG をコピー',
    },
    {
        id: 3439,
        label: 'レイヤー > CSS をコピー',
        placement: 'MenuBar',
        name: 'CSS をコピー',
    },
    {
        id: 3443,
        label: 'ファイル > 書き出し > 書き出し形式...',
        placement: 'MenuBar',
        name: '書き出し形式...',
    },
    {
        id: 3444,
        label: 'ファイル > 書き出し > PNG としてクイック書き出し',
        placement: 'MenuBar',
        name: 'PNG としてクイック書き出し',
    },
    {
        id: 3446,
        label: 'レイヤー > PNG としてクイック書き出し',
        placement: 'MenuBar',
        name: 'PNG としてクイック書き出し',
    },
    {
        id: 3447,
        label: 'レイヤー > 書き出し形式...',
        placement: 'MenuBar',
        name: '書き出し形式...',
    },
    {
        id: 3451,
        label: '書式 > 言語オプション > LTR アラビア語数字 - 123%',
        placement: 'MenuBar',
        name: 'LTR アラビア語数字 - 123%',
    },
    {
        id: 3452,
        label: '書式 > 言語オプション > ペルシア数字',
        placement: 'MenuBar',
        name: 'ペルシア数字',
    },
    {
        id: 3453,
        label: '書式 > 言語オプション > ヒンディー数字',
        placement: 'MenuBar',
        name: 'ヒンディー数字',
    },
    {
        id: 3459,
        label: '書式 > 言語オプション > RTL アラビア語数字 - %123',
        placement: 'MenuBar',
        name: 'RTL アラビア語数字 - %123',
    },
    {
        id: 3500,
        label: '表示 > エクストラ',
        placement: 'MenuBar',
        name: 'エクストラ',
    },
    {
        id: 3501,
        label: '表示 > 表示・非表示 > 選択範囲の境界線(S)',
        placement: 'MenuBar',
        name: '選択範囲の境界線(S)',
    },
    {
        id: 3502,
        label: '表示 > 表示・非表示 > ターゲットパス(P)',
        placement: 'MenuBar',
        name: 'ターゲットパス(P)',
    },
    {
        id: 3503,
        label: '表示 > 表示・非表示 > ガイド',
        placement: 'MenuBar',
        name: 'ガイド',
    },
    {
        id: 3504,
        label: '表示 > 表示・非表示 > グリッド(G)',
        placement: 'MenuBar',
        name: 'グリッド(G)',
    },
    {
        id: 3505,
        label: '表示 > 表示・非表示 > スライス(L)',
        placement: 'MenuBar',
        name: 'スライス(L)',
    },
    {
        id: 3506,
        label: '表示 > 表示・非表示 > 注釈(O)',
        placement: 'MenuBar',
        name: '注釈(O)',
    },
    {
        id: 3507,
        label: '表示 > 表示・非表示 > すべて',
        placement: 'MenuBar',
        name: 'すべて',
    },
    {
        id: 3508,
        label: '表示 > 表示・非表示 > なし',
        placement: 'MenuBar',
        name: 'なし',
    },
    {
        id: 3510,
        label: '表示 > 表示・非表示 > エクストラオプション...',
        placement: 'MenuBar',
        name: 'エクストラオプション...',
    },
    {
        id: 3511,
        label: '表示 > 表示・非表示 > スマートガイド(M)',
        placement: 'MenuBar',
        name: 'スマートガイド(M)',
    },
    {
        id: 3512,
        label: '表示 > 表示・非表示 > レイヤーの境界線(E)',
        placement: 'MenuBar',
        name: 'レイヤーの境界線(E)',
    },
    {
        id: 3513,
        label: '表示 > 表示・非表示 > カウント(C)',
        placement: 'MenuBar',
        name: 'カウント(C)',
    },
    {
        id: 3514,
        label: '表示 > 表示・非表示 > ピクセルグリッド(X)',
        placement: 'MenuBar',
        name: 'ピクセルグリッド(X)',
    },
    {
        id: 3517,
        label: '表示 > 表示・非表示 > メッシュ(H)',
        placement: 'MenuBar',
        name: 'メッシュ(H)',
    },
    {
        id: 3520,
        label: '表示 > スナップ',
        placement: 'MenuBar',
        name: 'スナップ',
    },
    {
        id: 3521,
        label: '表示 > スナップ先 > ガイド',
        placement: 'MenuBar',
        name: 'ガイド',
    },
    {
        id: 3522,
        label: '表示 > スナップ先 > グリッド',
        placement: 'MenuBar',
        name: 'グリッド',
    },
    {
        id: 3523,
        label: '表示 > スナップ先 > スライス',
        placement: 'MenuBar',
        name: 'スライス',
    },
    {
        id: 3524,
        label: '表示 > スナップ先 > ドキュメントの端',
        placement: 'MenuBar',
        name: 'ドキュメントの端',
    },
    {
        id: 3527,
        label: '表示 > スナップ先 > すべて',
        placement: 'MenuBar',
        name: 'すべて',
    },
    {
        id: 3528,
        label: '表示 > スナップ先 > なし',
        placement: 'MenuBar',
        name: 'なし',
    },
    {
        id: 3530,
        label: '表示 > スナップ先 > レイヤー',
        placement: 'MenuBar',
        name: 'レイヤー',
    },
    {
        id: 3532,
        label: '表示 > 表示・非表示 > パターンプレビューのタイルの境界',
        placement: 'MenuBar',
        name: 'パターンプレビューのタイルの境界',
    },
    {
        id: 3533,
        label: '表示 > 表示・非表示 > アートボードガイド',
        placement: 'MenuBar',
        name: 'アートボードガイド',
    },
    {
        id: 3535,
        label: '表示 > 表示・非表示 > アートボード名',
        placement: 'MenuBar',
        name: 'アートボード名',
    },
    {
        id: 3536,
        label: '表示 > 表示・非表示 > カンバスガイド',
        placement: 'MenuBar',
        name: 'カンバスガイド',
    },
    {
        id: 3541,
        label: 'レイヤー > ラスタライズ > シェイプ',
        placement: 'MenuBar',
        name: 'シェイプ',
    },
    {
        id: 3542,
        label: 'レイヤー > ラスタライズ > テキスト',
        placement: 'MenuBar',
        name: 'テキスト',
    },
    {
        id: 3542,
        label: '書式 > テキストレイヤーをラスタライズ',
        placement: 'MenuBar',
        name: 'テキストレイヤーをラスタライズ',
    },
    {
        id: 3544,
        label: 'レイヤー > ラスタライズ > 塗りつぶし内容',
        placement: 'MenuBar',
        name: '塗りつぶし内容',
    },
    {
        id: 3545,
        label: 'レイヤー > ラスタライズ > すべてのレイヤー',
        placement: 'MenuBar',
        name: 'すべてのレイヤー',
    },
    {
        id: 3547,
        label: 'レイヤー > ラスタライズ > レイヤー',
        placement: 'MenuBar',
        name: 'レイヤー',
    },
    {
        id: 3549,
        label: 'レイヤー > スマートオブジェクト > ラスタライズ',
        placement: 'MenuBar',
        name: 'ラスタライズ',
    },
    {
        id: 3549,
        label: 'レイヤー > ラスタライズ > スマートオブジェクト',
        placement: 'MenuBar',
        name: 'スマートオブジェクト',
    },
    {
        id: 3551,
        label: 'レイヤー > ラスタライズ > ビデオ',
        placement: 'MenuBar',
        name: 'ビデオ',
    },
    {
        id: 3553,
        label: 'レイヤー > ラスタライズ > 3D',
        placement: 'MenuBar',
        name: '3D',
    },
    {
        id: 3555,
        label: 'レイヤー > ビデオレイヤー > ラスタライズ',
        placement: 'MenuBar',
        name: 'ラスタライズ',
    },
    {
        id: 3557,
        label: 'レイヤー > ラスタライズ > レイヤースタイル',
        placement: 'MenuBar',
        name: 'レイヤースタイル',
    },
    {
        id: 3561,
        label: 'レイヤー > ラスタライズ > 生成',
        placement: 'MenuBar',
        name: '生成',
    },
    {
        id: 3585,
        label: '表示 > 表示・非表示 > 編集ピン',
        placement: 'MenuBar',
        name: '編集ピン',
    },
    {
        id: 3911,
        label: 'フィルター > 次世代フィルター > Blur (Gaussian)',
        placement: 'MenuBar',
        name: 'Blur (Gaussian)',
    },
    {
        id: 4002,
        label: 'ヘルプ > アップデート...',
        placement: 'MenuBar',
        name: 'アップデート...',
    },
    {
        id: 4210,
        label: 'ウィンドウ > ツールプリセット',
        placement: 'MenuBar',
        name: 'ツールプリセット',
    },
    {
        id: 5059,
        label: 'レイヤー > レイヤーマスク > 削除',
        placement: 'MenuBar',
        name: '削除',
    },
    {
        id: 5068,
        label: '編集 > 特殊ペースト > 選択範囲外へペースト',
        placement: 'MenuBar',
        name: '選択範囲外へペースト',
    },
    {
        id: 5069,
        label: '選択範囲 > クイックマスクモードで編集',
        placement: 'MenuBar',
        name: 'クイックマスクモードで編集',
    },
    {
        id: 5085,
        label: 'レイヤー > レイヤーマスク > リンク',
        placement: 'MenuBar',
        name: 'リンク',
    },
    {
        id: 5095,
        label: 'レイヤー > レイヤーマスク > 適用',
        placement: 'MenuBar',
        name: '適用',
    },
    {
        id: 5115,
        label: 'ウィンドウ > ワークスペース > 新規ワークスペース(N)...',
        placement: 'MenuBar',
        name: '新規ワークスペース(N)...',
    },
    {
        id: 5116,
        label: 'ウィンドウ > ワークスペース > ワークスペースを削除(D)...',
        placement: 'MenuBar',
        name: 'ワークスペースを削除(D)...',
    },
    {
        id: 5117,
        label: 'ウィンドウ > ワークスペース > 初期設定 をリセット(R)',
        placement: 'MenuBar',
        name: '初期設定 をリセット(R)',
    },
    {
        id: 5217,
        label: 'レイヤー > レイヤーに基づく新規スライス',
        placement: 'MenuBar',
        name: 'レイヤーに基づく新規スライス',
    },
    {
        id: 5226,
        label: 'レイヤー > スマートフィルター > フィルターマスクを削除',
        placement: 'MenuBar',
        name: 'フィルターマスクを削除',
    },
    {
        id: 5613,
        label: '表示 > ガイド > 新規ガイド...',
        placement: 'MenuBar',
        name: '新規ガイド...',
    },
    {
        id: 5614,
        label: '表示 > ガイド > 新規ガイドレイアウトを作成...',
        placement: 'MenuBar',
        name: '新規ガイドレイアウトを作成...',
    },
    {
        id: 5615,
        label: '表示 > ガイド > シェイプから新規ガイドを作成',
        placement: 'MenuBar',
        name: 'シェイプから新規ガイドを作成',
    },
    {
        id: 5624,
        label: '編集 > カスタムシェイプを定義...',
        placement: 'MenuBar',
        name: 'カスタムシェイプを定義...',
    },
    {
        id: 5634,
        label: 'ウィンドウ > ワークスペース > 初期設定(E)',
        placement: 'MenuBar',
        name: '初期設定(E)',
    },
    {
        id: 5929,
        label: 'ウィンドウ > アレンジ > すべてを前面へ',
        placement: 'MenuBar',
        name: 'すべてを前面へ',
    },
    {
        id: 5930,
        label: 'ウィンドウ > アレンジ > 重ねて表示',
        placement: 'MenuBar',
        name: '重ねて表示',
    },
    {
        id: 5931,
        label: 'ウィンドウ > アレンジ > 並べて表示',
        placement: 'MenuBar',
        name: '並べて表示',
    },
    {
        id: 5932,
        label: 'ウィンドウ > アレンジ > 最小化',
        placement: 'MenuBar',
        name: '最小化',
    },
    {
        id: 5933,
        label: 'ウィンドウ > アレンジ > すべてを水平方向に並べる',
        placement: 'MenuBar',
        name: 'すべてを水平方向に並べる',
    },
    {
        id: 5934,
        label: 'ウィンドウ > アレンジ > すべてを垂直方向に並べる',
        placement: 'MenuBar',
        name: 'すべてを垂直方向に並べる',
    },
    {
        id: 5935,
        label: 'ウィンドウ > アレンジ > 2 分割表示 - 水平方向',
        placement: 'MenuBar',
        name: '2 分割表示 - 水平方向',
    },
    {
        id: 5936,
        label: 'ウィンドウ > アレンジ > 2 分割表示 - 垂直方向',
        placement: 'MenuBar',
        name: '2 分割表示 - 垂直方向',
    },
    {
        id: 5937,
        label: 'ウィンドウ > アレンジ > 3 分割表示 - 水平方向',
        placement: 'MenuBar',
        name: '3 分割表示 - 水平方向',
    },
    {
        id: 5938,
        label: 'ウィンドウ > アレンジ > 3 分割表示 - 垂直方向',
        placement: 'MenuBar',
        name: '3 分割表示 - 垂直方向',
    },
    {
        id: 5939,
        label: 'ウィンドウ > アレンジ > 3 分割表示 - スタック',
        placement: 'MenuBar',
        name: '3 分割表示 - スタック',
    },
    {
        id: 5940,
        label: 'ウィンドウ > アレンジ > 4 分割表示',
        placement: 'MenuBar',
        name: '4 分割表示',
    },
    {
        id: 5941,
        label: 'ウィンドウ > アレンジ > 6 分割表示',
        placement: 'MenuBar',
        name: '6 分割表示',
    },
    {
        id: 5956,
        label: 'ヘルプ > Photoshop ヘルプ...',
        placement: 'MenuBar',
        name: 'Photoshop ヘルプ...',
    },
    {
        id: 5957,
        label: '編集 > 検索',
        placement: 'MenuBar',
        name: '検索',
    },
    {
        id: 5960,
        label: 'ウィンドウ > アレンジ > 表示サイズを一致',
        placement: 'MenuBar',
        name: '表示サイズを一致',
    },
    {
        id: 5962,
        label: 'ウィンドウ > アレンジ > 位置を一致',
        placement: 'MenuBar',
        name: '位置を一致',
    },
    {
        id: 5963,
        label: 'ウィンドウ > アレンジ > 回転を一致',
        placement: 'MenuBar',
        name: '回転を一致',
    },
    {
        id: 5964,
        label: 'ウィンドウ > アレンジ > すべてを一致',
        placement: 'MenuBar',
        name: 'すべてを一致',
    },
    {
        id: 5966,
        label: 'ファイル > レビュー用に共有',
        placement: 'MenuBar',
        name: 'レビュー用に共有',
    },
    {
        id: 5967,
        label: 'ファイル > 編集に招待...',
        placement: 'MenuBar',
        name: '編集に招待...',
    },
    {
        id: 5968,
        label: 'ファイル > 書き出し > Firefly ボードに送信',
        placement: 'MenuBar',
        name: 'Firefly ボードに送信',
    },
    {
        id: 5980,
        label: '編集 > キーボードショートカット...',
        placement: 'MenuBar',
        name: 'キーボードショートカット...',
    },
    {
        id: 5981,
        label: 'ウィンドウ > ワークスペース > キーボードショートカットとメニュー(K)...',
        placement: 'MenuBar',
        name: 'キーボードショートカットとメニュー(K)...',
    },
    {
        id: 5982,
        label: '編集 > メニュー...',
        placement: 'MenuBar',
        name: 'メニュー...',
    },
    {
        id: 5983,
        label: '編集 > ツールバー...',
        placement: 'MenuBar',
        name: 'ツールバー...',
    },
    {
        id: 5991,
        label: '表示 > スクリーンモード > 標準スクリーンモード',
        placement: 'MenuBar',
        name: '標準スクリーンモード',
    },
    {
        id: 5992,
        label: '表示 > スクリーンモード > メニュー付きフルスクリーンモード',
        placement: 'MenuBar',
        name: 'メニュー付きフルスクリーンモード',
    },
    {
        id: 5993,
        label: '表示 > スクリーンモード > フルスクリーンモード',
        placement: 'MenuBar',
        name: 'フルスクリーンモード',
    },
    {
        id: 5996,
        label: 'ウィンドウ > アレンジ > ウィンドウを分離',
        placement: 'MenuBar',
        name: 'ウィンドウを分離',
    },
    {
        id: 5997,
        label: 'ウィンドウ > アレンジ > すべてのウィンドウを分離',
        placement: 'MenuBar',
        name: 'すべてのウィンドウを分離',
    },
    {
        id: 5998,
        label: 'ウィンドウ > アレンジ > すべてをタブに統合',
        placement: 'MenuBar',
        name: 'すべてをタブに統合',
    },
    {
        id: 6300,
        label: 'レイヤー > 新規塗りつぶしレイヤー > べた塗り...',
        placement: 'MenuBar',
        name: 'べた塗り...',
    },
    {
        id: 6301,
        label: 'レイヤー > 新規塗りつぶしレイヤー > グラデーション...',
        placement: 'MenuBar',
        name: 'グラデーション...',
    },
    {
        id: 6302,
        label: 'レイヤー > 新規塗りつぶしレイヤー > パターン...',
        placement: 'MenuBar',
        name: 'パターン...',
    },
    {
        id: 6303,
        label: 'レイヤー > 新規調整レイヤー > レベル補正...',
        placement: 'MenuBar',
        name: 'レベル補正...',
    },
    {
        id: 6304,
        label: 'レイヤー > 新規調整レイヤー > トーンカーブ...',
        placement: 'MenuBar',
        name: 'トーンカーブ...',
    },
    {
        id: 6305,
        label: 'レイヤー > 新規調整レイヤー > カラーバランス...',
        placement: 'MenuBar',
        name: 'カラーバランス...',
    },
    {
        id: 6306,
        label: 'レイヤー > 新規調整レイヤー > 明るさ・コントラスト...',
        placement: 'MenuBar',
        name: '明るさ・コントラスト...',
    },
    {
        id: 6308,
        label: 'レイヤー > 新規調整レイヤー > 色相・彩度...',
        placement: 'MenuBar',
        name: '色相・彩度...',
    },
    {
        id: 6309,
        label: 'レイヤー > 新規調整レイヤー > 特定色域の選択...',
        placement: 'MenuBar',
        name: '特定色域の選択...',
    },
    {
        id: 6310,
        label: 'レイヤー > 新規調整レイヤー > チャンネルミキサー...',
        placement: 'MenuBar',
        name: 'チャンネルミキサー...',
    },
    {
        id: 6311,
        label: 'レイヤー > 新規調整レイヤー > グラデーションマップ...',
        placement: 'MenuBar',
        name: 'グラデーションマップ...',
    },
    {
        id: 6312,
        label: 'レイヤー > 新規調整レイヤー > レンズフィルター...',
        placement: 'MenuBar',
        name: 'レンズフィルター...',
    },
    {
        id: 6313,
        label: 'レイヤー > 新規調整レイヤー > 階調の反転...',
        placement: 'MenuBar',
        name: '階調の反転...',
    },
    {
        id: 6314,
        label: 'レイヤー > 新規調整レイヤー > 2 階調化...',
        placement: 'MenuBar',
        name: '2 階調化...',
    },
    {
        id: 6315,
        label: 'レイヤー > 新規調整レイヤー > ポスタリゼーション...',
        placement: 'MenuBar',
        name: 'ポスタリゼーション...',
    },
    {
        id: 6332,
        label: 'レイヤー > スマートオブジェクト > コンテンツを編集',
        placement: 'MenuBar',
        name: 'コンテンツを編集',
    },
    {
        id: 6333,
        label: 'レイヤー > スマートオブジェクト > コンテンツを置き換え...',
        placement: 'MenuBar',
        name: 'コンテンツを置き換え...',
    },
    {
        id: 6334,
        label: 'レイヤー > スマートオブジェクト > コンテンツを書き出し...',
        placement: 'MenuBar',
        name: 'コンテンツを書き出し...',
    },
    {
        id: 6337,
        label: 'レイヤー > 新規調整レイヤー > カラールックアップ...',
        placement: 'MenuBar',
        name: 'カラールックアップ...',
    },
    {
        id: 6339,
        label: 'レイヤー > スマートオブジェクト > リンクされたアイテムに変換...',
        placement: 'MenuBar',
        name: 'リンクされたアイテムに変換...',
    },
    {
        id: 6340,
        label: 'レイヤー > スマートオブジェクト > ファイルに再リンク...',
        placement: 'MenuBar',
        name: 'ファイルに再リンク...',
    },
    {
        id: 6341,
        label: 'レイヤー > スマートオブジェクト > ライブラリグラフィックに再リンク...',
        placement: 'MenuBar',
        name: 'ライブラリグラフィックに再リンク...',
    },
    {
        id: 6342,
        label: 'レイヤー > スマートオブジェクト > 変更されたコンテンツを更新',
        placement: 'MenuBar',
        name: '変更されたコンテンツを更新',
    },
    {
        id: 6343,
        label: 'レイヤー > スマートオブジェクト > 変更されたすべてのコンテンツを更新',
        placement: 'MenuBar',
        name: '変更されたすべてのコンテンツを更新',
    },
    {
        id: 6345,
        label: 'レイヤー > スマートオブジェクト > リンクされたアイテムの埋め込み',
        placement: 'MenuBar',
        name: 'リンクされたアイテムの埋め込み',
    },
    {
        id: 6346,
        label: 'レイヤー > スマートオブジェクト > リンクされたすべてのアイテムの埋め込み',
        placement: 'MenuBar',
        name: 'リンクされたすべてのアイテムの埋め込み',
    },
    {
        id: 6347,
        label: 'レイヤー > スマートオブジェクト > 変形を初期化',
        placement: 'MenuBar',
        name: '変形を初期化',
    },
    {
        id: 6348,
        label: 'レイヤー > 新規調整レイヤー > 白黒...',
        placement: 'MenuBar',
        name: '白黒...',
    },
    {
        id: 6351,
        label: 'レイヤー > ビデオレイヤー > 新規ビデオレイヤーをファイルから作成...',
        placement: 'MenuBar',
        name: '新規ビデオレイヤーをファイルから作成...',
    },
    {
        id: 6352,
        label: 'レイヤー > ビデオレイヤー > 空白の新規ビデオレイヤーを追加',
        placement: 'MenuBar',
        name: '空白の新規ビデオレイヤーを追加',
    },
    {
        id: 6353,
        label: 'レイヤー > ビデオレイヤー > 空白のフレームを挿入',
        placement: 'MenuBar',
        name: '空白のフレームを挿入',
    },
    {
        id: 6354,
        label: 'レイヤー > ビデオレイヤー > フレームを複製',
        placement: 'MenuBar',
        name: 'フレームを複製',
    },
    {
        id: 6355,
        label: 'レイヤー > ビデオレイヤー > フレームを削除',
        placement: 'MenuBar',
        name: 'フレームを削除',
    },
    {
        id: 6356,
        label: 'レイヤー > ビデオレイヤー > フッテージを変換...',
        placement: 'MenuBar',
        name: 'フッテージを変換...',
    },
    {
        id: 6357,
        label: 'レイヤー > ビデオレイヤー > フッテージを置き換え...',
        placement: 'MenuBar',
        name: 'フッテージを置き換え...',
    },
    {
        id: 6358,
        label: 'レイヤー > ビデオレイヤー > 変更されたビデオを表示',
        placement: 'MenuBar',
        name: '変更されたビデオを表示',
    },
    {
        id: 6360,
        label: 'レイヤー > ビデオレイヤー > フレームを復元',
        placement: 'MenuBar',
        name: 'フレームを復元',
    },
    {
        id: 6361,
        label: 'レイヤー > ビデオレイヤー > すべてのフレームを復元',
        placement: 'MenuBar',
        name: 'すべてのフレームを復元',
    },
    {
        id: 6362,
        label: 'ファイル > 読み込み > ビデオフレームからレイヤー...',
        placement: 'MenuBar',
        name: 'ビデオフレームからレイヤー...',
    },
    {
        id: 6363,
        label: 'レイヤー > ビデオレイヤー > フレームを再読み込み',
        placement: 'MenuBar',
        name: 'フレームを再読み込み',
    },
    {
        id: 6400,
        label: '表示 > 32 bit プレビューオプション...',
        placement: 'MenuBar',
        name: '32 bit プレビューオプション...',
    },
    {
        id: 6432,
        label: 'レイヤー > スマートオブジェクト > 画像のスタック > なし',
        placement: 'MenuBar',
        name: 'なし',
    },
    {
        id: 6440,
        label: 'フィルター > スマートフィルター用に変換',
        placement: 'MenuBar',
        name: 'スマートフィルター用に変換',
    },
    {
        id: 6478,
        label: 'ウィンドウ > プロパティ',
        placement: 'MenuBar',
        name: 'プロパティ',
    },
    {
        id: 6479,
        label: 'ウィンドウ > 色調補正',
        placement: 'MenuBar',
        name: '色調補正',
    },
    {
        id: 6651,
        label: 'レイヤー > 新規調整レイヤー > 明瞭度とかすみの除去...（C）',
        placement: 'MenuBar',
        name: '明瞭度とかすみの除去...（C）',
    },
    {
        id: 6652,
        label: 'レイヤー > 新規調整レイヤー > 粒子...',
        placement: 'MenuBar',
        name: '粒子...',
    },
    {
        id: 7763,
        label: 'ウィンドウ > グラデーション',
        placement: 'MenuBar',
        name: 'グラデーション',
    },
    {
        id: 7767,
        label: 'ウィンドウ > パターン',
        placement: 'MenuBar',
        name: 'パターン',
    },
    {
        id: 7772,
        label: 'ウィンドウ > シェイプ',
        placement: 'MenuBar',
        name: 'シェイプ',
    },
    {
        id: 7785,
        label: 'ウィンドウ > Content Credentials (Beta)',
        placement: 'MenuBar',
        name: 'Content Credentials (Beta)',
    },
    {
        id: 7788,
        label: 'ウィンドウ > マテリアル',
        placement: 'MenuBar',
        name: 'マテリアル',
    },
    {
        id: 7789,
        label: 'フィルター > パラメトリックフィルター...',
        placement: 'MenuBar',
        name: 'パラメトリックフィルター...',
    },
    {
        id: 7800,
        label: 'イメージ > データセットを適用...',
        placement: 'MenuBar',
        name: 'データセットを適用...',
    },
    {
        id: 7802,
        label: 'イメージ > 変数 > 定義...',
        placement: 'MenuBar',
        name: '定義...',
    },
    {
        id: 7803,
        label: 'イメージ > 変数 > データセット...',
        placement: 'MenuBar',
        name: 'データセット...',
    },
    {
        id: 7805,
        label: 'ファイル > 読み込み > 変数データセット...',
        placement: 'MenuBar',
        name: '変数データセット...',
    },
    {
        id: 7806,
        label: 'ファイル > 書き出し > データセットからファイル...',
        placement: 'MenuBar',
        name: 'データセットからファイル...',
    },
    {
        id: 7900,
        label: 'イメージ > 解析 > カウントツール',
        placement: 'MenuBar',
        name: 'カウントツール',
    },
    {
        id: 7930,
        label: 'ウィンドウ > アプリケーションフレーム',
        placement: 'MenuBar',
        name: 'アプリケーションフレーム',
    },
    {
        id: 8820,
        label: 'フィルター > ニューラルフィルター...',
        placement: 'MenuBar',
        name: 'ニューラルフィルター...',
    },
    {
        id: 9066,
        label: '書式 > パネル > 文字スタイルパネル',
        placement: 'MenuBar',
        name: '文字スタイルパネル',
    },
    {
        id: 9066,
        label: 'ウィンドウ > 文字スタイル',
        placement: 'MenuBar',
        name: '文字スタイル',
    },
    {
        id: 9067,
        label: '書式 > パネル > 段落スタイルパネル',
        placement: 'MenuBar',
        name: '段落スタイルパネル',
    },
    {
        id: 9067,
        label: 'ウィンドウ > 段落スタイル',
        placement: 'MenuBar',
        name: '段落スタイル',
    },
    {
        id: 9068,
        label: '書式 > パネル > 字形パネル',
        placement: 'MenuBar',
        name: '字形パネル',
    },
    {
        id: 9068,
        label: 'ウィンドウ > 字形',
        placement: 'MenuBar',
        name: '字形',
    },
    {
        id: 9086,
        label: '書式 > OpenType > 異体字のジャスティフィケーション',
        placement: 'MenuBar',
        name: '異体字のジャスティフィケーション',
    },
    {
        id: 9087,
        label: '書式 > 環境にないフォントを管理',
        placement: 'MenuBar',
        name: '環境にないフォントを管理',
    },
    {
        id: 9100,
        label: '書式 > 言語オプション > 初期設定の機能',
        placement: 'MenuBar',
        name: '初期設定の機能',
    },
    {
        id: 9101,
        label: '書式 > 言語オプション > 東アジア言語の機能',
        placement: 'MenuBar',
        name: '東アジア言語の機能',
    },
    {
        id: 9102,
        label: '書式 > 言語オプション > 中東言語の機能',
        placement: 'MenuBar',
        name: '中東言語の機能',
    },
    {
        id: 9109,
        label: '書式 > フォントプレビューのサイズ > なし',
        placement: 'MenuBar',
        name: 'なし',
    },
    {
        id: 9110,
        label: '書式 > フォントプレビューのサイズ > 小',
        placement: 'MenuBar',
        name: '小',
    },
    {
        id: 9111,
        label: '書式 > フォントプレビューのサイズ > 中',
        placement: 'MenuBar',
        name: '中',
    },
    {
        id: 9112,
        label: '書式 > フォントプレビューのサイズ > 大',
        placement: 'MenuBar',
        name: '大',
    },
    {
        id: 9113,
        label: '書式 > フォントプレビューのサイズ > 特大',
        placement: 'MenuBar',
        name: '特大',
    },
    {
        id: 9114,
        label: '書式 > フォントプレビューのサイズ > 超特大',
        placement: 'MenuBar',
        name: '超特大',
    },
    {
        id: 9119,
        label: '書式 > サンプルテキストの割付 (英語)',
        placement: 'MenuBar',
        name: 'サンプルテキストの割付 (英語)',
    },
    {
        id: 9121,
        label: '書式 > 初期設定のテキストスタイルを読み込み',
        placement: 'MenuBar',
        name: '初期設定のテキストスタイルを読み込み',
    },
    {
        id: 9122,
        label: '書式 > 初期設定のテキストスタイルを保存',
        placement: 'MenuBar',
        name: '初期設定のテキストスタイルを保存',
    },
    {
        id: 9123,
        label: '書式 > マッチフォント...',
        placement: 'MenuBar',
        name: 'マッチフォント...',
    },
    {
        id: 9130,
        label: '書式 > 言語オプション > 縦組み中の欧文回転',
        placement: 'MenuBar',
        name: '縦組み中の欧文回転',
    },
    {
        id: 9131,
        label: '書式 > 言語オプション > 縦中横',
        placement: 'MenuBar',
        name: '縦中横',
    },
    {
        id: 9132,
        label: '書式 > 言語オプション > 仮想ボディの上基準の行送り',
        placement: 'MenuBar',
        name: '仮想ボディの上基準の行送り',
    },
    {
        id: 9133,
        label: '書式 > 言語オプション > 欧文ベースライン基準の行送り',
        placement: 'MenuBar',
        name: '欧文ベースライン基準の行送り',
    },
    {
        id: 9137,
        label: '書式 > 言語オプション > Kashida',
        placement: 'MenuBar',
        name: 'Kashida',
    },
    {
        id: 9138,
        label: '書式 > 言語オプション > 初期設定の方向',
        placement: 'MenuBar',
        name: '初期設定の方向',
    },
    {
        id: 9139,
        label: '書式 > 言語オプション > 左から右方向の文字',
        placement: 'MenuBar',
        name: '左から右方向の文字',
    },
    {
        id: 9140,
        label: '書式 > 言語オプション > 右から左方向の文字',
        placement: 'MenuBar',
        name: '右から左方向の文字',
    },
    {
        id: 9143,
        label: '編集 > 特殊ペースト > 書式なしでペースト',
        placement: 'MenuBar',
        name: '書式なしでペースト',
    },
    {
        id: 9220,
        label: 'レイヤー > 新規 > アートボード...',
        placement: 'MenuBar',
        name: 'アートボード...',
    },
    {
        id: 9221,
        label: 'レイヤー > 新規 > グループからのアートボード',
        placement: 'MenuBar',
        name: 'グループからのアートボード',
    },
    {
        id: 9222,
        label: 'レイヤー > 新規 > レイヤーからのアートボード...',
        placement: 'MenuBar',
        name: 'レイヤーからのアートボード...',
    },
    {
        id: 9252,
        label: 'レイヤー > 新規 > レイヤーからのフレーム...',
        placement: 'MenuBar',
        name: 'レイヤーからのフレーム...',
    },
    {
        id: 9255,
        label: 'レイヤー > 新規 > フレームに変換',
        placement: 'MenuBar',
        name: 'フレームに変換',
    },
    {
        id: 9600,
        label: 'ウィンドウ > コンテキストタスクバー',
        placement: 'MenuBar',
        name: 'コンテキストタスクバー',
    },
    {
        id: 11600,
        label: 'レイヤー > 調和',
        placement: 'MenuBar',
        name: '調和',
    },
    {
        id: 15004,
        label: 'ヘルプ > システム情報...',
        placement: 'MenuBar',
        name: 'システム情報...',
    },
    {
        id: 15009,
        label: 'ヘルプ > GPU の互換性...',
        placement: 'MenuBar',
        name: 'GPU の互換性...',
    },
    {
        id: 15019,
        label: 'ヘルプ > 生成クレジットについての詳細',
        placement: 'MenuBar',
        name: '生成クレジットについての詳細',
    },
    {
        id: 15020,
        label: 'ヘルプ > アドビの生成 AI のユーザーガイドライン',
        placement: 'MenuBar',
        name: 'アドビの生成 AI のユーザーガイドライン',
    },
    {
        id: 15201,
        label: 'ファイル > Adobe Stock を検索...',
        placement: 'MenuBar',
        name: 'Adobe Stock を検索...',
    },
    {
        id: 15202,
        label: 'ファイル > Adobe Express のテンプレートの検索...',
        placement: 'MenuBar',
        name: 'Adobe Express のテンプレートの検索...',
    },
    {
        id: 15203,
        label: 'ヘルプ > 実践チュートリアル...',
        placement: 'MenuBar',
        name: '実践チュートリアル...',
    },
    {
        id: 15204,
        label: 'ヘルプ > 新機能...',
        placement: 'MenuBar',
        name: '新機能...',
    },
    {
        id: 17001,
        label: '編集 > 遠近法ワープ',
        placement: 'MenuBar',
        name: '遠近法ワープ',
    },
    {
        id: 20006,
        label: 'ファイル > バージョン履歴',
        placement: 'MenuBar',
        name: 'バージョン履歴',
    },
    {
        id: 20007,
        label: 'ウィンドウ > バージョン履歴',
        placement: 'MenuBar',
        name: 'バージョン履歴',
    },
    {
        id: 20008,
        label: 'ウィンドウ > コメント',
        placement: 'MenuBar',
        name: 'コメント',
    },
    {
        id: 21000,
        label: 'レイヤー > スマートオブジェクト > レイヤーに変換',
        placement: 'MenuBar',
        name: 'レイヤーに変換',
    },
    {
        id: 21001,
        label: '表示 > 画面にレイヤーを合わせる',
        placement: 'MenuBar',
        name: '画面にレイヤーを合わせる',
    },
    {
        id: 22003,
        label: '表示 > ガイド > 選択したガイドを編集',
        placement: 'MenuBar',
        name: '選択したガイドを編集',
    },
    {
        id: 22004,
        label: '表示 > ガイド > 選択したガイドを消去',
        placement: 'MenuBar',
        name: '選択したガイドを消去',
    },
    {
        id: 22100,
        label: 'レイヤー > すべてのオブジェクトをマスク',
        placement: 'MenuBar',
        name: 'すべてのオブジェクトをマスク',
    },
    {
        id: 23150,
        label: 'フィルター > フィルターの再実行',
        placement: 'MenuBar',
        name: 'フィルターの再実行',
    },
    {
        id: 23151,
        label: 'フィルター > フィルターの再実行',
        placement: 'MenuBar',
        name: 'フィルターの再実行',
    },
    {
        id: 23152,
        label: 'フィルター > フィルターの再実行',
        placement: 'MenuBar',
        name: 'フィルターの再実行',
    },
    {
        id: 23153,
        label: 'フィルター > フィルターの再実行',
        placement: 'MenuBar',
        name: 'フィルターの再実行',
    },
    {
        id: 25070,
        label: '編集 > オブジェクトを回転',
        placement: 'MenuBar',
        name: 'オブジェクトを回転',
    },
    {
        id: 26010,
        label: '編集 > 反射の削除...',
        placement: 'MenuBar',
        name: '反射の削除...',
    },
    {
        id: 30900,
        label: 'ファイル > 無料の Adobe Stock 画像を配置...',
        placement: 'MenuBar',
        name: '無料の Adobe Stock 画像を配置...',
    },
    {
        id: 'paintbrushTool',
        label: 'ブラシツール',
        placement: 'Tool',
    },
    {
        id: 'adjustmentBrushTool',
        label: '調整ブラシツール',
        placement: 'Tool',
    },
    {
        id: 'pencilTool',
        label: '鉛筆ツール',
        placement: 'Tool',
    },
    {
        id: 'colorReplacementBrushTool',
        label: '色の置き換えツール',
        placement: 'Tool',
    },
    {
        id: 'wetBrushTool',
        label: '混合ブラシツール',
        placement: 'Tool',
    },
    {
        id: 'eraserTool',
        label: '消しゴムツール',
        placement: 'Tool',
    },
    {
        id: 'backgroundEraserTool',
        label: '背景消しゴムツール',
        placement: 'Tool',
    },
    {
        id: 'cloneStampTool',
        label: 'コピースタンプツール',
        placement: 'Tool',
    },
    {
        id: 'patternStampTool',
        label: 'パターンスタンプツール',
        placement: 'Tool',
    },
    {
        id: 'magicStampTool',
        label: '修復ブラシツール',
        placement: 'Tool',
    },
    {
        id: 'historyBrushTool',
        label: 'ヒストリーブラシツール',
        placement: 'Tool',
    },
    {
        id: 'artBrushTool',
        label: 'アートヒストリーブラシツール',
        placement: 'Tool',
    },
    {
        id: 'smudgeTool',
        label: '指先ツール',
        placement: 'Tool',
    },
    {
        id: 'blurTool',
        label: 'ぼかしツール',
        placement: 'Tool',
    },
    {
        id: 'sharpenTool',
        label: 'シャープツール',
        placement: 'Tool',
    },
    {
        id: 'dodgeTool',
        label: '覆い焼きツール',
        placement: 'Tool',
    },
    {
        id: 'burnInTool',
        label: '焼き込みツール',
        placement: 'Tool',
    },
    {
        id: 'saturationTool',
        label: 'スポンジツール',
        placement: 'Tool',
    },
    {
        id: 'redEyeTool',
        label: '赤目修正ツール',
        placement: 'Tool',
    },
    {
        id: 'marqueeRectTool',
        label: '長方形選択ツール',
        placement: 'Tool',
    },
    {
        id: 'marqueeEllipTool',
        label: '楕円形選択ツール',
        placement: 'Tool',
    },
    {
        id: 'marqueeSingleRowTool',
        label: '一行選択ツール',
        placement: 'Tool',
    },
    {
        id: 'marqueeSingleColumnTool',
        label: '一列選択ツール',
        placement: 'Tool',
    },
    {
        id: 'moveTool',
        label: '移動ツール',
        placement: 'Tool',
    },
    {
        id: 'artboardTool',
        label: 'アートボードツール',
        placement: 'Tool',
    },
    {
        id: 'lassoTool',
        label: 'なげなわツール',
        placement: 'Tool',
    },
    {
        id: 'selectionBrushTool',
        label: '選択ブラシツール',
        placement: 'Tool',
    },
    {
        id: 'magicLassoTool',
        label: 'オブジェクト選択ツール',
        placement: 'Tool',
    },
    {
        id: 'polySelTool',
        label: '多角形選択ツール',
        placement: 'Tool',
    },
    {
        id: 'magneticLassoTool',
        label: 'マグネット選択ツール',
        placement: 'Tool',
    },
    {
        id: 'magicWandTool',
        label: '自動選択ツール',
        placement: 'Tool',
    },
    {
        id: 'quickSelectTool',
        label: 'クイック選択ツール',
        placement: 'Tool',
    },
    {
        id: 'cropTool',
        label: '切り抜きツール',
        placement: 'Tool',
    },
    {
        id: 'perspectiveCropTool',
        label: '遠近法の切り抜きツール',
        placement: 'Tool',
    },
    {
        id: 'sliceTool',
        label: 'スライスツール',
        placement: 'Tool',
    },
    {
        id: 'sliceSelectTool',
        label: 'スライス選択ツール',
        placement: 'Tool',
    },
    {
        id: 'magicEraserTool',
        label: 'マジック消しゴムツール',
        placement: 'Tool',
    },
    {
        id: 'gradientTool',
        label: 'グラデーションツール',
        placement: 'Tool',
    },
    {
        id: 'bucketTool',
        label: '塗りつぶしツール',
        placement: 'Tool',
    },
    {
        id: 'pathComponentSelectTool',
        label: 'パスコンポーネント選択ツール',
        placement: 'Tool',
    },
    {
        id: 'directSelectTool',
        label: 'パス選択ツール',
        placement: 'Tool',
    },
    {
        id: 'penTool',
        label: 'ペンツール',
        placement: 'Tool',
    },
    {
        id: 'freeformPenTool',
        label: 'フリーフォームペンツール',
        placement: 'Tool',
    },
    {
        id: 'curvaturePenTool',
        label: '曲線ペンツール',
        placement: 'Tool',
    },
    {
        id: 'addKnotTool',
        label: 'アンカーポイントの追加ツール',
        placement: 'Tool',
    },
    {
        id: 'deleteKnotTool',
        label: 'アンカーポイントの削除ツール',
        placement: 'Tool',
    },
    {
        id: 'convertKnotTool',
        label: 'アンカーポイントの切り替えツール',
        placement: 'Tool',
    },
    {
        id: 'typeCreateOrEditTool',
        label: '横書き文字ツール',
        placement: 'Tool',
    },
    {
        id: 'typeVerticalCreateOrEditTool',
        label: '縦書き文字ツール',
        placement: 'Tool',
    },
    {
        id: 'typeCreateMaskTool',
        label: '横書き文字マスクツール',
        placement: 'Tool',
    },
    {
        id: 'typeVerticalCreateMaskTool',
        label: '縦書き文字マスクツール',
        placement: 'Tool',
    },
    {
        id: 'rectangleTool',
        label: '長方形ツール',
        placement: 'Tool',
    },
    {
        id: 'ellipseTool',
        label: '楕円形ツール',
        placement: 'Tool',
    },
    {
        id: 'triangleTool',
        label: '三角形ツール',
        placement: 'Tool',
    },
    {
        id: 'polygonTool',
        label: '多角形ツール',
        placement: 'Tool',
    },
    {
        id: 'lineTool',
        label: 'ラインツール',
        placement: 'Tool',
    },
    {
        id: 'customShapeTool',
        label: 'カスタムシェイプツール',
        placement: 'Tool',
    },
    {
        id: 'StarTool',
        label: 'スターツール',
        placement: 'Tool',
    },
    {
        id: 'framedGroupTool',
        label: 'フレームツール',
        placement: 'Tool',
    },
    {
        id: 'eyedropperTool',
        label: 'スポイトツール',
        placement: 'Tool',
    },
    {
        id: 'colorSamplerTool',
        label: 'カラーサンプラーツール',
        placement: 'Tool',
    },
    {
        id: 'rulerTool',
        label: 'ものさしツール',
        placement: 'Tool',
    },
    {
        id: 'textAnnotTool',
        label: '注釈ツール',
        placement: 'Tool',
    },
    {
        id: 'handTool',
        label: '手のひらツール',
        placement: 'Tool',
    },
    {
        id: 'rotateTool',
        label: '回転ビューツール',
        placement: 'Tool',
    },
    {
        id: 'zoomTool',
        label: 'ズームツール',
        placement: 'Tool',
    },
    {
        id: 'patchSelection',
        label: 'パッチツール',
        placement: 'Tool',
    },
    {
        id: 'recomposeSelection',
        label: 'コンテンツに応じた移動ツール',
        placement: 'Tool',
    },
    {
        id: 'spotHealingBrushTool',
        label: 'スポット修復ブラシツール',
        placement: 'Tool',
    },
    {
        id: 'removeTool',
        label: '削除ツール',
        placement: 'Tool',
    },
    {
        id: 'editToolbar',
        label: 'ツールバーを編集...',
        placement: 'Tool',
    },
    {
        id: 'countTool',
        label: 'カウントツール',
        placement: 'Tool',
    },
    {
        id: 'panelid.static.actions',
        label: 'アクション',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.gradients',
        label: 'グラデーション',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.styles',
        label: 'スタイル',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.swatches',
        label: 'スウォッチ',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.patterns',
        label: 'パターン',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.histogram',
        label: 'ヒストグラム',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.info',
        label: '情報',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.paths',
        label: 'パス',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.customshapes',
        label: 'シェイプ',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.toolpresets',
        label: 'ツールプリセット',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.picker',
        label: 'カラー',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.channels',
        label: 'チャンネル',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.layers',
        label: 'レイヤー',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.comps',
        label: 'レイヤーカンプ',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.animation',
        label: 'タイムライン',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.clonesource',
        label: 'コピーソース',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.measurement',
        label: '計測ログ',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.hdrpreview',
        label: 'HDR プレビュー',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.history',
        label: 'ヒストリー',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.navigator',
        label: 'ナビゲーター',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textcharacter',
        label: '文字',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textparagraph',
        label: '段落',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textcharstyle',
        label: '文字スタイル',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textparastyle',
        label: '段落スタイル',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textglyphspanel',
        label: '字形',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.annotation',
        label: '注釈',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.properties',
        label: 'プロパティ',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.cai.uxp/panel',
        label: 'Content Credentials (Beta)',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.cclibrariespanel/ccLibrariesPanel',
        label: 'CC ライブラリ',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.ccx.comments-webview/ccx-comments-uxp-webview',
        label: 'コメント',
        placement: 'Panel',
    },
    {
        id: 'actionId:$dytx;selectorId:context_bar',
        label: 'コンテキストバー : ダイナミックテキスト',
        placement: 'Option',
    },
    {
        id: 'actionId:$dytx;selectorId:properties',
        label: 'パネル : ダイナミックテキスト',
        placement: 'Option',
    },
    {
        id: 'actionId:$dytx;selectorId:options',
        label: 'ツール : ダイナミックテキスト',
        placement: 'Option',
    },
];
